// --- BEGIN AUTO-GENERATED FILE ---
//
// @IconsVersion: 1.11.3
// @Generated: 2025-07-07T10:11:55.726Z
//
// This file is generated on each build. Do not edit this file!

import { pluginFactoryNoConfig } from '../utils/plugins'

// Icon helper component
import { BIcon } from './icon'

// Icon stacking component
import { BIconstack } from './iconstack'

import {
  // BootstrapVue custom icons
  BIconBlank,
  // Bootstrap icons
  BIcon0Circle,
  BIcon0CircleFill,
  BIcon0Square,
  BIcon0SquareFill,
  BIcon123,
  BIcon1Circle,
  BIcon1CircleFill,
  BIcon1Square,
  BIcon1SquareFill,
  BIcon2Circle,
  BIcon2CircleFill,
  BIcon2Square,
  BIcon2SquareFill,
  BIcon3Circle,
  BIcon3CircleFill,
  BIcon3Square,
  BIcon3SquareFill,
  BIcon4Circle,
  BIcon4CircleFill,
  BIcon4Square,
  BIcon4SquareFill,
  BIcon5Circle,
  BIcon5CircleFill,
  BIcon5Square,
  BIcon5SquareFill,
  BIcon6Circle,
  BIcon6CircleFill,
  BIcon6Square,
  BIcon6SquareFill,
  BIcon7Circle,
  BIcon7CircleFill,
  BIcon7Square,
  BIcon7SquareFill,
  BIcon8Circle,
  BIcon8CircleFill,
  BIcon8Square,
  BIcon8SquareFill,
  BIcon9Circle,
  BIcon9CircleFill,
  BIcon9Square,
  BIcon9SquareFill,
  BIconActivity,
  BIconAirplane,
  BIconAirplaneEngines,
  BIconAirplaneEnginesFill,
  BIconAirplaneFill,
  BIconAlarm,
  BIconAlarmFill,
  BIconAlexa,
  BIconAlignBottom,
  BIconAlignCenter,
  BIconAlignEnd,
  BIconAlignMiddle,
  BIconAlignStart,
  BIconAlignTop,
  BIconAlipay,
  BIconAlphabet,
  BIconAlphabetUppercase,
  BIconAlt,
  BIconAmazon,
  BIconAmd,
  BIconAndroid,
  BIconAndroid2,
  BIconApp,
  BIconAppIndicator,
  BIconApple,
  BIconArchive,
  BIconArchiveFill,
  BIconArrow90degDown,
  BIconArrow90degLeft,
  BIconArrow90degRight,
  BIconArrow90degUp,
  BIconArrowBarDown,
  BIconArrowBarLeft,
  BIconArrowBarRight,
  BIconArrowBarUp,
  BIconArrowClockwise,
  BIconArrowCounterclockwise,
  BIconArrowDown,
  BIconArrowDownCircle,
  BIconArrowDownCircleFill,
  BIconArrowDownLeft,
  BIconArrowDownLeftCircle,
  BIconArrowDownLeftCircleFill,
  BIconArrowDownLeftSquare,
  BIconArrowDownLeftSquareFill,
  BIconArrowDownRight,
  BIconArrowDownRightCircle,
  BIconArrowDownRightCircleFill,
  BIconArrowDownRightSquare,
  BIconArrowDownRightSquareFill,
  BIconArrowDownShort,
  BIconArrowDownSquare,
  BIconArrowDownSquareFill,
  BIconArrowDownUp,
  BIconArrowLeft,
  BIconArrowLeftCircle,
  BIconArrowLeftCircleFill,
  BIconArrowLeftRight,
  BIconArrowLeftShort,
  BIconArrowLeftSquare,
  BIconArrowLeftSquareFill,
  BIconArrowRepeat,
  BIconArrowReturnLeft,
  BIconArrowReturnRight,
  BIconArrowRight,
  BIconArrowRightCircle,
  BIconArrowRightCircleFill,
  BIconArrowRightShort,
  BIconArrowRightSquare,
  BIconArrowRightSquareFill,
  BIconArrowThroughHeart,
  BIconArrowThroughHeartFill,
  BIconArrowUp,
  BIconArrowUpCircle,
  BIconArrowUpCircleFill,
  BIconArrowUpLeft,
  BIconArrowUpLeftCircle,
  BIconArrowUpLeftCircleFill,
  BIconArrowUpLeftSquare,
  BIconArrowUpLeftSquareFill,
  BIconArrowUpRight,
  BIconArrowUpRightCircle,
  BIconArrowUpRightCircleFill,
  BIconArrowUpRightSquare,
  BIconArrowUpRightSquareFill,
  BIconArrowUpShort,
  BIconArrowUpSquare,
  BIconArrowUpSquareFill,
  BIconArrows,
  BIconArrowsAngleContract,
  BIconArrowsAngleExpand,
  BIconArrowsCollapse,
  BIconArrowsCollapseVertical,
  BIconArrowsExpand,
  BIconArrowsExpandVertical,
  BIconArrowsFullscreen,
  BIconArrowsMove,
  BIconArrowsVertical,
  BIconAspectRatio,
  BIconAspectRatioFill,
  BIconAsterisk,
  BIconAt,
  BIconAward,
  BIconAwardFill,
  BIconBack,
  BIconBackpack,
  BIconBackpack2,
  BIconBackpack2Fill,
  BIconBackpack3,
  BIconBackpack3Fill,
  BIconBackpack4,
  BIconBackpack4Fill,
  BIconBackpackFill,
  BIconBackspace,
  BIconBackspaceFill,
  BIconBackspaceReverse,
  BIconBackspaceReverseFill,
  BIconBadge3d,
  BIconBadge3dFill,
  BIconBadge4k,
  BIconBadge4kFill,
  BIconBadge8k,
  BIconBadge8kFill,
  BIconBadgeAd,
  BIconBadgeAdFill,
  BIconBadgeAr,
  BIconBadgeArFill,
  BIconBadgeCc,
  BIconBadgeCcFill,
  BIconBadgeHd,
  BIconBadgeHdFill,
  BIconBadgeSd,
  BIconBadgeSdFill,
  BIconBadgeTm,
  BIconBadgeTmFill,
  BIconBadgeVo,
  BIconBadgeVoFill,
  BIconBadgeVr,
  BIconBadgeVrFill,
  BIconBadgeWc,
  BIconBadgeWcFill,
  BIconBag,
  BIconBagCheck,
  BIconBagCheckFill,
  BIconBagDash,
  BIconBagDashFill,
  BIconBagFill,
  BIconBagHeart,
  BIconBagHeartFill,
  BIconBagPlus,
  BIconBagPlusFill,
  BIconBagX,
  BIconBagXFill,
  BIconBalloon,
  BIconBalloonFill,
  BIconBalloonHeart,
  BIconBalloonHeartFill,
  BIconBan,
  BIconBanFill,
  BIconBandaid,
  BIconBandaidFill,
  BIconBank,
  BIconBank2,
  BIconBarChart,
  BIconBarChartFill,
  BIconBarChartLine,
  BIconBarChartLineFill,
  BIconBarChartSteps,
  BIconBasket,
  BIconBasket2,
  BIconBasket2Fill,
  BIconBasket3,
  BIconBasket3Fill,
  BIconBasketFill,
  BIconBattery,
  BIconBatteryCharging,
  BIconBatteryFull,
  BIconBatteryHalf,
  BIconBehance,
  BIconBell,
  BIconBellFill,
  BIconBellSlash,
  BIconBellSlashFill,
  BIconBezier,
  BIconBezier2,
  BIconBicycle,
  BIconBing,
  BIconBinoculars,
  BIconBinocularsFill,
  BIconBlockquoteLeft,
  BIconBlockquoteRight,
  BIconBluetooth,
  BIconBodyText,
  BIconBook,
  BIconBookFill,
  BIconBookHalf,
  BIconBookmark,
  BIconBookmarkCheck,
  BIconBookmarkCheckFill,
  BIconBookmarkDash,
  BIconBookmarkDashFill,
  BIconBookmarkFill,
  BIconBookmarkHeart,
  BIconBookmarkHeartFill,
  BIconBookmarkPlus,
  BIconBookmarkPlusFill,
  BIconBookmarkStar,
  BIconBookmarkStarFill,
  BIconBookmarkX,
  BIconBookmarkXFill,
  BIconBookmarks,
  BIconBookmarksFill,
  BIconBookshelf,
  BIconBoombox,
  BIconBoomboxFill,
  BIconBootstrap,
  BIconBootstrapFill,
  BIconBootstrapReboot,
  BIconBorder,
  BIconBorderAll,
  BIconBorderBottom,
  BIconBorderCenter,
  BIconBorderInner,
  BIconBorderLeft,
  BIconBorderMiddle,
  BIconBorderOuter,
  BIconBorderRight,
  BIconBorderStyle,
  BIconBorderTop,
  BIconBorderWidth,
  BIconBoundingBox,
  BIconBoundingBoxCircles,
  BIconBox,
  BIconBox2,
  BIconBox2Fill,
  BIconBox2Heart,
  BIconBox2HeartFill,
  BIconBoxArrowDown,
  BIconBoxArrowDownLeft,
  BIconBoxArrowDownRight,
  BIconBoxArrowInDown,
  BIconBoxArrowInDownLeft,
  BIconBoxArrowInDownRight,
  BIconBoxArrowInLeft,
  BIconBoxArrowInRight,
  BIconBoxArrowInUp,
  BIconBoxArrowInUpLeft,
  BIconBoxArrowInUpRight,
  BIconBoxArrowLeft,
  BIconBoxArrowRight,
  BIconBoxArrowUp,
  BIconBoxArrowUpLeft,
  BIconBoxArrowUpRight,
  BIconBoxFill,
  BIconBoxSeam,
  BIconBoxSeamFill,
  BIconBoxes,
  BIconBraces,
  BIconBracesAsterisk,
  BIconBricks,
  BIconBriefcase,
  BIconBriefcaseFill,
  BIconBrightnessAltHigh,
  BIconBrightnessAltHighFill,
  BIconBrightnessAltLow,
  BIconBrightnessAltLowFill,
  BIconBrightnessHigh,
  BIconBrightnessHighFill,
  BIconBrightnessLow,
  BIconBrightnessLowFill,
  BIconBrilliance,
  BIconBroadcast,
  BIconBroadcastPin,
  BIconBrowserChrome,
  BIconBrowserEdge,
  BIconBrowserFirefox,
  BIconBrowserSafari,
  BIconBrush,
  BIconBrushFill,
  BIconBucket,
  BIconBucketFill,
  BIconBug,
  BIconBugFill,
  BIconBuilding,
  BIconBuildingAdd,
  BIconBuildingCheck,
  BIconBuildingDash,
  BIconBuildingDown,
  BIconBuildingExclamation,
  BIconBuildingFill,
  BIconBuildingFillAdd,
  BIconBuildingFillCheck,
  BIconBuildingFillDash,
  BIconBuildingFillDown,
  BIconBuildingFillExclamation,
  BIconBuildingFillGear,
  BIconBuildingFillLock,
  BIconBuildingFillSlash,
  BIconBuildingFillUp,
  BIconBuildingFillX,
  BIconBuildingGear,
  BIconBuildingLock,
  BIconBuildingSlash,
  BIconBuildingUp,
  BIconBuildingX,
  BIconBuildings,
  BIconBuildingsFill,
  BIconBullseye,
  BIconBusFront,
  BIconBusFrontFill,
  BIconCCircle,
  BIconCCircleFill,
  BIconCSquare,
  BIconCSquareFill,
  BIconCake,
  BIconCake2,
  BIconCake2Fill,
  BIconCakeFill,
  BIconCalculator,
  BIconCalculatorFill,
  BIconCalendar,
  BIconCalendar2,
  BIconCalendar2Check,
  BIconCalendar2CheckFill,
  BIconCalendar2Date,
  BIconCalendar2DateFill,
  BIconCalendar2Day,
  BIconCalendar2DayFill,
  BIconCalendar2Event,
  BIconCalendar2EventFill,
  BIconCalendar2Fill,
  BIconCalendar2Heart,
  BIconCalendar2HeartFill,
  BIconCalendar2Minus,
  BIconCalendar2MinusFill,
  BIconCalendar2Month,
  BIconCalendar2MonthFill,
  BIconCalendar2Plus,
  BIconCalendar2PlusFill,
  BIconCalendar2Range,
  BIconCalendar2RangeFill,
  BIconCalendar2Week,
  BIconCalendar2WeekFill,
  BIconCalendar2X,
  BIconCalendar2XFill,
  BIconCalendar3,
  BIconCalendar3Event,
  BIconCalendar3EventFill,
  BIconCalendar3Fill,
  BIconCalendar3Range,
  BIconCalendar3RangeFill,
  BIconCalendar3Week,
  BIconCalendar3WeekFill,
  BIconCalendar4,
  BIconCalendar4Event,
  BIconCalendar4Range,
  BIconCalendar4Week,
  BIconCalendarCheck,
  BIconCalendarCheckFill,
  BIconCalendarDate,
  BIconCalendarDateFill,
  BIconCalendarDay,
  BIconCalendarDayFill,
  BIconCalendarEvent,
  BIconCalendarEventFill,
  BIconCalendarFill,
  BIconCalendarHeart,
  BIconCalendarHeartFill,
  BIconCalendarMinus,
  BIconCalendarMinusFill,
  BIconCalendarMonth,
  BIconCalendarMonthFill,
  BIconCalendarPlus,
  BIconCalendarPlusFill,
  BIconCalendarRange,
  BIconCalendarRangeFill,
  BIconCalendarWeek,
  BIconCalendarWeekFill,
  BIconCalendarX,
  BIconCalendarXFill,
  BIconCamera,
  BIconCamera2,
  BIconCameraFill,
  BIconCameraReels,
  BIconCameraReelsFill,
  BIconCameraVideo,
  BIconCameraVideoFill,
  BIconCameraVideoOff,
  BIconCameraVideoOffFill,
  BIconCapslock,
  BIconCapslockFill,
  BIconCapsule,
  BIconCapsulePill,
  BIconCarFront,
  BIconCarFrontFill,
  BIconCardChecklist,
  BIconCardHeading,
  BIconCardImage,
  BIconCardList,
  BIconCardText,
  BIconCaretDown,
  BIconCaretDownFill,
  BIconCaretDownSquare,
  BIconCaretDownSquareFill,
  BIconCaretLeft,
  BIconCaretLeftFill,
  BIconCaretLeftSquare,
  BIconCaretLeftSquareFill,
  BIconCaretRight,
  BIconCaretRightFill,
  BIconCaretRightSquare,
  BIconCaretRightSquareFill,
  BIconCaretUp,
  BIconCaretUpFill,
  BIconCaretUpSquare,
  BIconCaretUpSquareFill,
  BIconCart,
  BIconCart2,
  BIconCart3,
  BIconCart4,
  BIconCartCheck,
  BIconCartCheckFill,
  BIconCartDash,
  BIconCartDashFill,
  BIconCartFill,
  BIconCartPlus,
  BIconCartPlusFill,
  BIconCartX,
  BIconCartXFill,
  BIconCash,
  BIconCashCoin,
  BIconCashStack,
  BIconCassette,
  BIconCassetteFill,
  BIconCast,
  BIconCcCircle,
  BIconCcCircleFill,
  BIconCcSquare,
  BIconCcSquareFill,
  BIconChat,
  BIconChatDots,
  BIconChatDotsFill,
  BIconChatFill,
  BIconChatHeart,
  BIconChatHeartFill,
  BIconChatLeft,
  BIconChatLeftDots,
  BIconChatLeftDotsFill,
  BIconChatLeftFill,
  BIconChatLeftHeart,
  BIconChatLeftHeartFill,
  BIconChatLeftQuote,
  BIconChatLeftQuoteFill,
  BIconChatLeftText,
  BIconChatLeftTextFill,
  BIconChatQuote,
  BIconChatQuoteFill,
  BIconChatRight,
  BIconChatRightDots,
  BIconChatRightDotsFill,
  BIconChatRightFill,
  BIconChatRightHeart,
  BIconChatRightHeartFill,
  BIconChatRightQuote,
  BIconChatRightQuoteFill,
  BIconChatRightText,
  BIconChatRightTextFill,
  BIconChatSquare,
  BIconChatSquareDots,
  BIconChatSquareDotsFill,
  BIconChatSquareFill,
  BIconChatSquareHeart,
  BIconChatSquareHeartFill,
  BIconChatSquareQuote,
  BIconChatSquareQuoteFill,
  BIconChatSquareText,
  BIconChatSquareTextFill,
  BIconChatText,
  BIconChatTextFill,
  BIconCheck,
  BIconCheck2,
  BIconCheck2All,
  BIconCheck2Circle,
  BIconCheck2Square,
  BIconCheckAll,
  BIconCheckCircle,
  BIconCheckCircleFill,
  BIconCheckLg,
  BIconCheckSquare,
  BIconCheckSquareFill,
  BIconChevronBarContract,
  BIconChevronBarDown,
  BIconChevronBarExpand,
  BIconChevronBarLeft,
  BIconChevronBarRight,
  BIconChevronBarUp,
  BIconChevronCompactDown,
  BIconChevronCompactLeft,
  BIconChevronCompactRight,
  BIconChevronCompactUp,
  BIconChevronContract,
  BIconChevronDoubleDown,
  BIconChevronDoubleLeft,
  BIconChevronDoubleRight,
  BIconChevronDoubleUp,
  BIconChevronDown,
  BIconChevronExpand,
  BIconChevronLeft,
  BIconChevronRight,
  BIconChevronUp,
  BIconCircle,
  BIconCircleFill,
  BIconCircleHalf,
  BIconCircleSquare,
  BIconClipboard,
  BIconClipboard2,
  BIconClipboard2Check,
  BIconClipboard2CheckFill,
  BIconClipboard2Data,
  BIconClipboard2DataFill,
  BIconClipboard2Fill,
  BIconClipboard2Heart,
  BIconClipboard2HeartFill,
  BIconClipboard2Minus,
  BIconClipboard2MinusFill,
  BIconClipboard2Plus,
  BIconClipboard2PlusFill,
  BIconClipboard2Pulse,
  BIconClipboard2PulseFill,
  BIconClipboard2X,
  BIconClipboard2XFill,
  BIconClipboardCheck,
  BIconClipboardCheckFill,
  BIconClipboardData,
  BIconClipboardDataFill,
  BIconClipboardFill,
  BIconClipboardHeart,
  BIconClipboardHeartFill,
  BIconClipboardMinus,
  BIconClipboardMinusFill,
  BIconClipboardPlus,
  BIconClipboardPlusFill,
  BIconClipboardPulse,
  BIconClipboardX,
  BIconClipboardXFill,
  BIconClock,
  BIconClockFill,
  BIconClockHistory,
  BIconCloud,
  BIconCloudArrowDown,
  BIconCloudArrowDownFill,
  BIconCloudArrowUp,
  BIconCloudArrowUpFill,
  BIconCloudCheck,
  BIconCloudCheckFill,
  BIconCloudDownload,
  BIconCloudDownloadFill,
  BIconCloudDrizzle,
  BIconCloudDrizzleFill,
  BIconCloudFill,
  BIconCloudFog,
  BIconCloudFog2,
  BIconCloudFog2Fill,
  BIconCloudFogFill,
  BIconCloudHail,
  BIconCloudHailFill,
  BIconCloudHaze,
  BIconCloudHaze2,
  BIconCloudHaze2Fill,
  BIconCloudHazeFill,
  BIconCloudLightning,
  BIconCloudLightningFill,
  BIconCloudLightningRain,
  BIconCloudLightningRainFill,
  BIconCloudMinus,
  BIconCloudMinusFill,
  BIconCloudMoon,
  BIconCloudMoonFill,
  BIconCloudPlus,
  BIconCloudPlusFill,
  BIconCloudRain,
  BIconCloudRainFill,
  BIconCloudRainHeavy,
  BIconCloudRainHeavyFill,
  BIconCloudSlash,
  BIconCloudSlashFill,
  BIconCloudSleet,
  BIconCloudSleetFill,
  BIconCloudSnow,
  BIconCloudSnowFill,
  BIconCloudSun,
  BIconCloudSunFill,
  BIconCloudUpload,
  BIconCloudUploadFill,
  BIconClouds,
  BIconCloudsFill,
  BIconCloudy,
  BIconCloudyFill,
  BIconCode,
  BIconCodeSlash,
  BIconCodeSquare,
  BIconCoin,
  BIconCollection,
  BIconCollectionFill,
  BIconCollectionPlay,
  BIconCollectionPlayFill,
  BIconColumns,
  BIconColumnsGap,
  BIconCommand,
  BIconCompass,
  BIconCompassFill,
  BIconCone,
  BIconConeStriped,
  BIconController,
  BIconCookie,
  BIconCopy,
  BIconCpu,
  BIconCpuFill,
  BIconCreditCard,
  BIconCreditCard2Back,
  BIconCreditCard2BackFill,
  BIconCreditCard2Front,
  BIconCreditCard2FrontFill,
  BIconCreditCardFill,
  BIconCrop,
  BIconCrosshair,
  BIconCrosshair2,
  BIconCup,
  BIconCupFill,
  BIconCupHot,
  BIconCupHotFill,
  BIconCupStraw,
  BIconCurrencyBitcoin,
  BIconCurrencyDollar,
  BIconCurrencyEuro,
  BIconCurrencyExchange,
  BIconCurrencyPound,
  BIconCurrencyRupee,
  BIconCurrencyYen,
  BIconCursor,
  BIconCursorFill,
  BIconCursorText,
  BIconDash,
  BIconDashCircle,
  BIconDashCircleDotted,
  BIconDashCircleFill,
  BIconDashLg,
  BIconDashSquare,
  BIconDashSquareDotted,
  BIconDashSquareFill,
  BIconDatabase,
  BIconDatabaseAdd,
  BIconDatabaseCheck,
  BIconDatabaseDash,
  BIconDatabaseDown,
  BIconDatabaseExclamation,
  BIconDatabaseFill,
  BIconDatabaseFillAdd,
  BIconDatabaseFillCheck,
  BIconDatabaseFillDash,
  BIconDatabaseFillDown,
  BIconDatabaseFillExclamation,
  BIconDatabaseFillGear,
  BIconDatabaseFillLock,
  BIconDatabaseFillSlash,
  BIconDatabaseFillUp,
  BIconDatabaseFillX,
  BIconDatabaseGear,
  BIconDatabaseLock,
  BIconDatabaseSlash,
  BIconDatabaseUp,
  BIconDatabaseX,
  BIconDeviceHdd,
  BIconDeviceHddFill,
  BIconDeviceSsd,
  BIconDeviceSsdFill,
  BIconDiagram2,
  BIconDiagram2Fill,
  BIconDiagram3,
  BIconDiagram3Fill,
  BIconDiamond,
  BIconDiamondFill,
  BIconDiamondHalf,
  BIconDice1,
  BIconDice1Fill,
  BIconDice2,
  BIconDice2Fill,
  BIconDice3,
  BIconDice3Fill,
  BIconDice4,
  BIconDice4Fill,
  BIconDice5,
  BIconDice5Fill,
  BIconDice6,
  BIconDice6Fill,
  BIconDisc,
  BIconDiscFill,
  BIconDiscord,
  BIconDisplay,
  BIconDisplayFill,
  BIconDisplayport,
  BIconDisplayportFill,
  BIconDistributeHorizontal,
  BIconDistributeVertical,
  BIconDoorClosed,
  BIconDoorClosedFill,
  BIconDoorOpen,
  BIconDoorOpenFill,
  BIconDot,
  BIconDownload,
  BIconDpad,
  BIconDpadFill,
  BIconDribbble,
  BIconDropbox,
  BIconDroplet,
  BIconDropletFill,
  BIconDropletHalf,
  BIconDuffle,
  BIconDuffleFill,
  BIconEar,
  BIconEarFill,
  BIconEarbuds,
  BIconEasel,
  BIconEasel2,
  BIconEasel2Fill,
  BIconEasel3,
  BIconEasel3Fill,
  BIconEaselFill,
  BIconEgg,
  BIconEggFill,
  BIconEggFried,
  BIconEject,
  BIconEjectFill,
  BIconEmojiAngry,
  BIconEmojiAngryFill,
  BIconEmojiAstonished,
  BIconEmojiAstonishedFill,
  BIconEmojiDizzy,
  BIconEmojiDizzyFill,
  BIconEmojiExpressionless,
  BIconEmojiExpressionlessFill,
  BIconEmojiFrown,
  BIconEmojiFrownFill,
  BIconEmojiGrimace,
  BIconEmojiGrimaceFill,
  BIconEmojiGrin,
  BIconEmojiGrinFill,
  BIconEmojiHeartEyes,
  BIconEmojiHeartEyesFill,
  BIconEmojiKiss,
  BIconEmojiKissFill,
  BIconEmojiLaughing,
  BIconEmojiLaughingFill,
  BIconEmojiNeutral,
  BIconEmojiNeutralFill,
  BIconEmojiSmile,
  BIconEmojiSmileFill,
  BIconEmojiSmileUpsideDown,
  BIconEmojiSmileUpsideDownFill,
  BIconEmojiSunglasses,
  BIconEmojiSunglassesFill,
  BIconEmojiSurprise,
  BIconEmojiSurpriseFill,
  BIconEmojiTear,
  BIconEmojiTearFill,
  BIconEmojiWink,
  BIconEmojiWinkFill,
  BIconEnvelope,
  BIconEnvelopeArrowDown,
  BIconEnvelopeArrowDownFill,
  BIconEnvelopeArrowUp,
  BIconEnvelopeArrowUpFill,
  BIconEnvelopeAt,
  BIconEnvelopeAtFill,
  BIconEnvelopeCheck,
  BIconEnvelopeCheckFill,
  BIconEnvelopeDash,
  BIconEnvelopeDashFill,
  BIconEnvelopeExclamation,
  BIconEnvelopeExclamationFill,
  BIconEnvelopeFill,
  BIconEnvelopeHeart,
  BIconEnvelopeHeartFill,
  BIconEnvelopeOpen,
  BIconEnvelopeOpenFill,
  BIconEnvelopeOpenHeart,
  BIconEnvelopeOpenHeartFill,
  BIconEnvelopePaper,
  BIconEnvelopePaperFill,
  BIconEnvelopePaperHeart,
  BIconEnvelopePaperHeartFill,
  BIconEnvelopePlus,
  BIconEnvelopePlusFill,
  BIconEnvelopeSlash,
  BIconEnvelopeSlashFill,
  BIconEnvelopeX,
  BIconEnvelopeXFill,
  BIconEraser,
  BIconEraserFill,
  BIconEscape,
  BIconEthernet,
  BIconEvFront,
  BIconEvFrontFill,
  BIconEvStation,
  BIconEvStationFill,
  BIconExclamation,
  BIconExclamationCircle,
  BIconExclamationCircleFill,
  BIconExclamationDiamond,
  BIconExclamationDiamondFill,
  BIconExclamationLg,
  BIconExclamationOctagon,
  BIconExclamationOctagonFill,
  BIconExclamationSquare,
  BIconExclamationSquareFill,
  BIconExclamationTriangle,
  BIconExclamationTriangleFill,
  BIconExclude,
  BIconExplicit,
  BIconExplicitFill,
  BIconExposure,
  BIconEye,
  BIconEyeFill,
  BIconEyeSlash,
  BIconEyeSlashFill,
  BIconEyedropper,
  BIconEyeglasses,
  BIconFacebook,
  BIconFan,
  BIconFastForward,
  BIconFastForwardBtn,
  BIconFastForwardBtnFill,
  BIconFastForwardCircle,
  BIconFastForwardCircleFill,
  BIconFastForwardFill,
  BIconFeather,
  BIconFeather2,
  BIconFile,
  BIconFileArrowDown,
  BIconFileArrowDownFill,
  BIconFileArrowUp,
  BIconFileArrowUpFill,
  BIconFileBarGraph,
  BIconFileBarGraphFill,
  BIconFileBinary,
  BIconFileBinaryFill,
  BIconFileBreak,
  BIconFileBreakFill,
  BIconFileCheck,
  BIconFileCheckFill,
  BIconFileCode,
  BIconFileCodeFill,
  BIconFileDiff,
  BIconFileDiffFill,
  BIconFileEarmark,
  BIconFileEarmarkArrowDown,
  BIconFileEarmarkArrowDownFill,
  BIconFileEarmarkArrowUp,
  BIconFileEarmarkArrowUpFill,
  BIconFileEarmarkBarGraph,
  BIconFileEarmarkBarGraphFill,
  BIconFileEarmarkBinary,
  BIconFileEarmarkBinaryFill,
  BIconFileEarmarkBreak,
  BIconFileEarmarkBreakFill,
  BIconFileEarmarkCheck,
  BIconFileEarmarkCheckFill,
  BIconFileEarmarkCode,
  BIconFileEarmarkCodeFill,
  BIconFileEarmarkDiff,
  BIconFileEarmarkDiffFill,
  BIconFileEarmarkEasel,
  BIconFileEarmarkEaselFill,
  BIconFileEarmarkExcel,
  BIconFileEarmarkExcelFill,
  BIconFileEarmarkFill,
  BIconFileEarmarkFont,
  BIconFileEarmarkFontFill,
  BIconFileEarmarkImage,
  BIconFileEarmarkImageFill,
  BIconFileEarmarkLock,
  BIconFileEarmarkLock2,
  BIconFileEarmarkLock2Fill,
  BIconFileEarmarkLockFill,
  BIconFileEarmarkMedical,
  BIconFileEarmarkMedicalFill,
  BIconFileEarmarkMinus,
  BIconFileEarmarkMinusFill,
  BIconFileEarmarkMusic,
  BIconFileEarmarkMusicFill,
  BIconFileEarmarkPdf,
  BIconFileEarmarkPdfFill,
  BIconFileEarmarkPerson,
  BIconFileEarmarkPersonFill,
  BIconFileEarmarkPlay,
  BIconFileEarmarkPlayFill,
  BIconFileEarmarkPlus,
  BIconFileEarmarkPlusFill,
  BIconFileEarmarkPost,
  BIconFileEarmarkPostFill,
  BIconFileEarmarkPpt,
  BIconFileEarmarkPptFill,
  BIconFileEarmarkRichtext,
  BIconFileEarmarkRichtextFill,
  BIconFileEarmarkRuled,
  BIconFileEarmarkRuledFill,
  BIconFileEarmarkSlides,
  BIconFileEarmarkSlidesFill,
  BIconFileEarmarkSpreadsheet,
  BIconFileEarmarkSpreadsheetFill,
  BIconFileEarmarkText,
  BIconFileEarmarkTextFill,
  BIconFileEarmarkWord,
  BIconFileEarmarkWordFill,
  BIconFileEarmarkX,
  BIconFileEarmarkXFill,
  BIconFileEarmarkZip,
  BIconFileEarmarkZipFill,
  BIconFileEasel,
  BIconFileEaselFill,
  BIconFileExcel,
  BIconFileExcelFill,
  BIconFileFill,
  BIconFileFont,
  BIconFileFontFill,
  BIconFileImage,
  BIconFileImageFill,
  BIconFileLock,
  BIconFileLock2,
  BIconFileLock2Fill,
  BIconFileLockFill,
  BIconFileMedical,
  BIconFileMedicalFill,
  BIconFileMinus,
  BIconFileMinusFill,
  BIconFileMusic,
  BIconFileMusicFill,
  BIconFilePdf,
  BIconFilePdfFill,
  BIconFilePerson,
  BIconFilePersonFill,
  BIconFilePlay,
  BIconFilePlayFill,
  BIconFilePlus,
  BIconFilePlusFill,
  BIconFilePost,
  BIconFilePostFill,
  BIconFilePpt,
  BIconFilePptFill,
  BIconFileRichtext,
  BIconFileRichtextFill,
  BIconFileRuled,
  BIconFileRuledFill,
  BIconFileSlides,
  BIconFileSlidesFill,
  BIconFileSpreadsheet,
  BIconFileSpreadsheetFill,
  BIconFileText,
  BIconFileTextFill,
  BIconFileWord,
  BIconFileWordFill,
  BIconFileX,
  BIconFileXFill,
  BIconFileZip,
  BIconFileZipFill,
  BIconFiles,
  BIconFilesAlt,
  BIconFiletypeAac,
  BIconFiletypeAi,
  BIconFiletypeBmp,
  BIconFiletypeCs,
  BIconFiletypeCss,
  BIconFiletypeCsv,
  BIconFiletypeDoc,
  BIconFiletypeDocx,
  BIconFiletypeExe,
  BIconFiletypeGif,
  BIconFiletypeHeic,
  BIconFiletypeHtml,
  BIconFiletypeJava,
  BIconFiletypeJpg,
  BIconFiletypeJs,
  BIconFiletypeJson,
  BIconFiletypeJsx,
  BIconFiletypeKey,
  BIconFiletypeM4p,
  BIconFiletypeMd,
  BIconFiletypeMdx,
  BIconFiletypeMov,
  BIconFiletypeMp3,
  BIconFiletypeMp4,
  BIconFiletypeOtf,
  BIconFiletypePdf,
  BIconFiletypePhp,
  BIconFiletypePng,
  BIconFiletypePpt,
  BIconFiletypePptx,
  BIconFiletypePsd,
  BIconFiletypePy,
  BIconFiletypeRaw,
  BIconFiletypeRb,
  BIconFiletypeSass,
  BIconFiletypeScss,
  BIconFiletypeSh,
  BIconFiletypeSql,
  BIconFiletypeSvg,
  BIconFiletypeTiff,
  BIconFiletypeTsx,
  BIconFiletypeTtf,
  BIconFiletypeTxt,
  BIconFiletypeWav,
  BIconFiletypeWoff,
  BIconFiletypeXls,
  BIconFiletypeXlsx,
  BIconFiletypeXml,
  BIconFiletypeYml,
  BIconFilm,
  BIconFilter,
  BIconFilterCircle,
  BIconFilterCircleFill,
  BIconFilterLeft,
  BIconFilterRight,
  BIconFilterSquare,
  BIconFilterSquareFill,
  BIconFingerprint,
  BIconFire,
  BIconFlag,
  BIconFlagFill,
  BIconFloppy,
  BIconFloppy2,
  BIconFloppy2Fill,
  BIconFloppyFill,
  BIconFlower1,
  BIconFlower2,
  BIconFlower3,
  BIconFolder,
  BIconFolder2,
  BIconFolder2Open,
  BIconFolderCheck,
  BIconFolderFill,
  BIconFolderMinus,
  BIconFolderPlus,
  BIconFolderSymlink,
  BIconFolderSymlinkFill,
  BIconFolderX,
  BIconFonts,
  BIconForward,
  BIconForwardFill,
  BIconFront,
  BIconFuelPump,
  BIconFuelPumpDiesel,
  BIconFuelPumpDieselFill,
  BIconFuelPumpFill,
  BIconFullscreen,
  BIconFullscreenExit,
  BIconFunnel,
  BIconFunnelFill,
  BIconGear,
  BIconGearFill,
  BIconGearWide,
  BIconGearWideConnected,
  BIconGem,
  BIconGenderAmbiguous,
  BIconGenderFemale,
  BIconGenderMale,
  BIconGenderNeuter,
  BIconGenderTrans,
  BIconGeo,
  BIconGeoAlt,
  BIconGeoAltFill,
  BIconGeoFill,
  BIconGift,
  BIconGiftFill,
  BIconGit,
  BIconGithub,
  BIconGitlab,
  BIconGlobe,
  BIconGlobe2,
  BIconGlobeAmericas,
  BIconGlobeAsiaAustralia,
  BIconGlobeCentralSouthAsia,
  BIconGlobeEuropeAfrica,
  BIconGoogle,
  BIconGooglePlay,
  BIconGpuCard,
  BIconGraphDown,
  BIconGraphDownArrow,
  BIconGraphUp,
  BIconGraphUpArrow,
  BIconGrid,
  BIconGrid1x2,
  BIconGrid1x2Fill,
  BIconGrid3x2,
  BIconGrid3x2Gap,
  BIconGrid3x2GapFill,
  BIconGrid3x3,
  BIconGrid3x3Gap,
  BIconGrid3x3GapFill,
  BIconGridFill,
  BIconGripHorizontal,
  BIconGripVertical,
  BIconHCircle,
  BIconHCircleFill,
  BIconHSquare,
  BIconHSquareFill,
  BIconHammer,
  BIconHandIndex,
  BIconHandIndexFill,
  BIconHandIndexThumb,
  BIconHandIndexThumbFill,
  BIconHandThumbsDown,
  BIconHandThumbsDownFill,
  BIconHandThumbsUp,
  BIconHandThumbsUpFill,
  BIconHandbag,
  BIconHandbagFill,
  BIconHash,
  BIconHdd,
  BIconHddFill,
  BIconHddNetwork,
  BIconHddNetworkFill,
  BIconHddRack,
  BIconHddRackFill,
  BIconHddStack,
  BIconHddStackFill,
  BIconHdmi,
  BIconHdmiFill,
  BIconHeadphones,
  BIconHeadset,
  BIconHeadsetVr,
  BIconHeart,
  BIconHeartArrow,
  BIconHeartFill,
  BIconHeartHalf,
  BIconHeartPulse,
  BIconHeartPulseFill,
  BIconHeartbreak,
  BIconHeartbreakFill,
  BIconHearts,
  BIconHeptagon,
  BIconHeptagonFill,
  BIconHeptagonHalf,
  BIconHexagon,
  BIconHexagonFill,
  BIconHexagonHalf,
  BIconHighlighter,
  BIconHighlights,
  BIconHospital,
  BIconHospitalFill,
  BIconHourglass,
  BIconHourglassBottom,
  BIconHourglassSplit,
  BIconHourglassTop,
  BIconHouse,
  BIconHouseAdd,
  BIconHouseAddFill,
  BIconHouseCheck,
  BIconHouseCheckFill,
  BIconHouseDash,
  BIconHouseDashFill,
  BIconHouseDoor,
  BIconHouseDoorFill,
  BIconHouseDown,
  BIconHouseDownFill,
  BIconHouseExclamation,
  BIconHouseExclamationFill,
  BIconHouseFill,
  BIconHouseGear,
  BIconHouseGearFill,
  BIconHouseHeart,
  BIconHouseHeartFill,
  BIconHouseLock,
  BIconHouseLockFill,
  BIconHouseSlash,
  BIconHouseSlashFill,
  BIconHouseUp,
  BIconHouseUpFill,
  BIconHouseX,
  BIconHouseXFill,
  BIconHouses,
  BIconHousesFill,
  BIconHr,
  BIconHurricane,
  BIconHypnotize,
  BIconImage,
  BIconImageAlt,
  BIconImageFill,
  BIconImages,
  BIconInbox,
  BIconInboxFill,
  BIconInboxes,
  BIconInboxesFill,
  BIconIncognito,
  BIconIndent,
  BIconInfinity,
  BIconInfo,
  BIconInfoCircle,
  BIconInfoCircleFill,
  BIconInfoLg,
  BIconInfoSquare,
  BIconInfoSquareFill,
  BIconInputCursor,
  BIconInputCursorText,
  BIconInstagram,
  BIconIntersect,
  BIconJournal,
  BIconJournalAlbum,
  BIconJournalArrowDown,
  BIconJournalArrowUp,
  BIconJournalBookmark,
  BIconJournalBookmarkFill,
  BIconJournalCheck,
  BIconJournalCode,
  BIconJournalMedical,
  BIconJournalMinus,
  BIconJournalPlus,
  BIconJournalRichtext,
  BIconJournalText,
  BIconJournalX,
  BIconJournals,
  BIconJoystick,
  BIconJustify,
  BIconJustifyLeft,
  BIconJustifyRight,
  BIconKanban,
  BIconKanbanFill,
  BIconKey,
  BIconKeyFill,
  BIconKeyboard,
  BIconKeyboardFill,
  BIconLadder,
  BIconLamp,
  BIconLampFill,
  BIconLaptop,
  BIconLaptopFill,
  BIconLayerBackward,
  BIconLayerForward,
  BIconLayers,
  BIconLayersFill,
  BIconLayersHalf,
  BIconLayoutSidebar,
  BIconLayoutSidebarInset,
  BIconLayoutSidebarInsetReverse,
  BIconLayoutSidebarReverse,
  BIconLayoutSplit,
  BIconLayoutTextSidebar,
  BIconLayoutTextSidebarReverse,
  BIconLayoutTextWindow,
  BIconLayoutTextWindowReverse,
  BIconLayoutThreeColumns,
  BIconLayoutWtf,
  BIconLifePreserver,
  BIconLightbulb,
  BIconLightbulbFill,
  BIconLightbulbOff,
  BIconLightbulbOffFill,
  BIconLightning,
  BIconLightningCharge,
  BIconLightningChargeFill,
  BIconLightningFill,
  BIconLine,
  BIconLink,
  BIconLink45deg,
  BIconLinkedin,
  BIconList,
  BIconListCheck,
  BIconListColumns,
  BIconListColumnsReverse,
  BIconListNested,
  BIconListOl,
  BIconListStars,
  BIconListTask,
  BIconListUl,
  BIconLock,
  BIconLockFill,
  BIconLuggage,
  BIconLuggageFill,
  BIconLungs,
  BIconLungsFill,
  BIconMagic,
  BIconMagnet,
  BIconMagnetFill,
  BIconMailbox,
  BIconMailbox2,
  BIconMailbox2Flag,
  BIconMailboxFlag,
  BIconMap,
  BIconMapFill,
  BIconMarkdown,
  BIconMarkdownFill,
  BIconMarkerTip,
  BIconMask,
  BIconMastodon,
  BIconMedium,
  BIconMegaphone,
  BIconMegaphoneFill,
  BIconMemory,
  BIconMenuApp,
  BIconMenuAppFill,
  BIconMenuButton,
  BIconMenuButtonFill,
  BIconMenuButtonWide,
  BIconMenuButtonWideFill,
  BIconMenuDown,
  BIconMenuUp,
  BIconMessenger,
  BIconMeta,
  BIconMic,
  BIconMicFill,
  BIconMicMute,
  BIconMicMuteFill,
  BIconMicrosoft,
  BIconMicrosoftTeams,
  BIconMinecart,
  BIconMinecartLoaded,
  BIconModem,
  BIconModemFill,
  BIconMoisture,
  BIconMoon,
  BIconMoonFill,
  BIconMoonStars,
  BIconMoonStarsFill,
  BIconMortarboard,
  BIconMortarboardFill,
  BIconMotherboard,
  BIconMotherboardFill,
  BIconMouse,
  BIconMouse2,
  BIconMouse2Fill,
  BIconMouse3,
  BIconMouse3Fill,
  BIconMouseFill,
  BIconMusicNote,
  BIconMusicNoteBeamed,
  BIconMusicNoteList,
  BIconMusicPlayer,
  BIconMusicPlayerFill,
  BIconNewspaper,
  BIconNintendoSwitch,
  BIconNodeMinus,
  BIconNodeMinusFill,
  BIconNodePlus,
  BIconNodePlusFill,
  BIconNoiseReduction,
  BIconNut,
  BIconNutFill,
  BIconNvidia,
  BIconNvme,
  BIconNvmeFill,
  BIconOctagon,
  BIconOctagonFill,
  BIconOctagonHalf,
  BIconOpencollective,
  BIconOpticalAudio,
  BIconOpticalAudioFill,
  BIconOption,
  BIconOutlet,
  BIconPCircle,
  BIconPCircleFill,
  BIconPSquare,
  BIconPSquareFill,
  BIconPaintBucket,
  BIconPalette,
  BIconPalette2,
  BIconPaletteFill,
  BIconPaperclip,
  BIconParagraph,
  BIconPass,
  BIconPassFill,
  BIconPassport,
  BIconPassportFill,
  BIconPatchCheck,
  BIconPatchCheckFill,
  BIconPatchExclamation,
  BIconPatchExclamationFill,
  BIconPatchMinus,
  BIconPatchMinusFill,
  BIconPatchPlus,
  BIconPatchPlusFill,
  BIconPatchQuestion,
  BIconPatchQuestionFill,
  BIconPause,
  BIconPauseBtn,
  BIconPauseBtnFill,
  BIconPauseCircle,
  BIconPauseCircleFill,
  BIconPauseFill,
  BIconPaypal,
  BIconPc,
  BIconPcDisplay,
  BIconPcDisplayHorizontal,
  BIconPcHorizontal,
  BIconPciCard,
  BIconPciCardNetwork,
  BIconPciCardSound,
  BIconPeace,
  BIconPeaceFill,
  BIconPen,
  BIconPenFill,
  BIconPencil,
  BIconPencilFill,
  BIconPencilSquare,
  BIconPentagon,
  BIconPentagonFill,
  BIconPentagonHalf,
  BIconPeople,
  BIconPeopleFill,
  BIconPercent,
  BIconPerson,
  BIconPersonAdd,
  BIconPersonArmsUp,
  BIconPersonBadge,
  BIconPersonBadgeFill,
  BIconPersonBoundingBox,
  BIconPersonCheck,
  BIconPersonCheckFill,
  BIconPersonCircle,
  BIconPersonDash,
  BIconPersonDashFill,
  BIconPersonDown,
  BIconPersonExclamation,
  BIconPersonFill,
  BIconPersonFillAdd,
  BIconPersonFillCheck,
  BIconPersonFillDash,
  BIconPersonFillDown,
  BIconPersonFillExclamation,
  BIconPersonFillGear,
  BIconPersonFillLock,
  BIconPersonFillSlash,
  BIconPersonFillUp,
  BIconPersonFillX,
  BIconPersonGear,
  BIconPersonHeart,
  BIconPersonHearts,
  BIconPersonLinesFill,
  BIconPersonLock,
  BIconPersonPlus,
  BIconPersonPlusFill,
  BIconPersonRaisedHand,
  BIconPersonRolodex,
  BIconPersonSlash,
  BIconPersonSquare,
  BIconPersonStanding,
  BIconPersonStandingDress,
  BIconPersonUp,
  BIconPersonVcard,
  BIconPersonVcardFill,
  BIconPersonVideo,
  BIconPersonVideo2,
  BIconPersonVideo3,
  BIconPersonWalking,
  BIconPersonWheelchair,
  BIconPersonWorkspace,
  BIconPersonX,
  BIconPersonXFill,
  BIconPhone,
  BIconPhoneFill,
  BIconPhoneFlip,
  BIconPhoneLandscape,
  BIconPhoneLandscapeFill,
  BIconPhoneVibrate,
  BIconPhoneVibrateFill,
  BIconPieChart,
  BIconPieChartFill,
  BIconPiggyBank,
  BIconPiggyBankFill,
  BIconPin,
  BIconPinAngle,
  BIconPinAngleFill,
  BIconPinFill,
  BIconPinMap,
  BIconPinMapFill,
  BIconPinterest,
  BIconPip,
  BIconPipFill,
  BIconPlay,
  BIconPlayBtn,
  BIconPlayBtnFill,
  BIconPlayCircle,
  BIconPlayCircleFill,
  BIconPlayFill,
  BIconPlaystation,
  BIconPlug,
  BIconPlugFill,
  BIconPlugin,
  BIconPlus,
  BIconPlusCircle,
  BIconPlusCircleDotted,
  BIconPlusCircleFill,
  BIconPlusLg,
  BIconPlusSlashMinus,
  BIconPlusSquare,
  BIconPlusSquareDotted,
  BIconPlusSquareFill,
  BIconPostage,
  BIconPostageFill,
  BIconPostageHeart,
  BIconPostageHeartFill,
  BIconPostcard,
  BIconPostcardFill,
  BIconPostcardHeart,
  BIconPostcardHeartFill,
  BIconPower,
  BIconPrescription,
  BIconPrescription2,
  BIconPrinter,
  BIconPrinterFill,
  BIconProjector,
  BIconProjectorFill,
  BIconPuzzle,
  BIconPuzzleFill,
  BIconQrCode,
  BIconQrCodeScan,
  BIconQuestion,
  BIconQuestionCircle,
  BIconQuestionCircleFill,
  BIconQuestionDiamond,
  BIconQuestionDiamondFill,
  BIconQuestionLg,
  BIconQuestionOctagon,
  BIconQuestionOctagonFill,
  BIconQuestionSquare,
  BIconQuestionSquareFill,
  BIconQuora,
  BIconQuote,
  BIconRCircle,
  BIconRCircleFill,
  BIconRSquare,
  BIconRSquareFill,
  BIconRadar,
  BIconRadioactive,
  BIconRainbow,
  BIconReceipt,
  BIconReceiptCutoff,
  BIconReception0,
  BIconReception1,
  BIconReception2,
  BIconReception3,
  BIconReception4,
  BIconRecord,
  BIconRecord2,
  BIconRecord2Fill,
  BIconRecordBtn,
  BIconRecordBtnFill,
  BIconRecordCircle,
  BIconRecordCircleFill,
  BIconRecordFill,
  BIconRecycle,
  BIconReddit,
  BIconRegex,
  BIconRepeat,
  BIconRepeat1,
  BIconReply,
  BIconReplyAll,
  BIconReplyAllFill,
  BIconReplyFill,
  BIconRewind,
  BIconRewindBtn,
  BIconRewindBtnFill,
  BIconRewindCircle,
  BIconRewindCircleFill,
  BIconRewindFill,
  BIconRobot,
  BIconRocket,
  BIconRocketFill,
  BIconRocketTakeoff,
  BIconRocketTakeoffFill,
  BIconRouter,
  BIconRouterFill,
  BIconRss,
  BIconRssFill,
  BIconRulers,
  BIconSafe,
  BIconSafe2,
  BIconSafe2Fill,
  BIconSafeFill,
  BIconSave,
  BIconSave2,
  BIconSave2Fill,
  BIconSaveFill,
  BIconScissors,
  BIconScooter,
  BIconScrewdriver,
  BIconSdCard,
  BIconSdCardFill,
  BIconSearch,
  BIconSearchHeart,
  BIconSearchHeartFill,
  BIconSegmentedNav,
  BIconSend,
  BIconSendArrowDown,
  BIconSendArrowDownFill,
  BIconSendArrowUp,
  BIconSendArrowUpFill,
  BIconSendCheck,
  BIconSendCheckFill,
  BIconSendDash,
  BIconSendDashFill,
  BIconSendExclamation,
  BIconSendExclamationFill,
  BIconSendFill,
  BIconSendPlus,
  BIconSendPlusFill,
  BIconSendSlash,
  BIconSendSlashFill,
  BIconSendX,
  BIconSendXFill,
  BIconServer,
  BIconShadows,
  BIconShare,
  BIconShareFill,
  BIconShield,
  BIconShieldCheck,
  BIconShieldExclamation,
  BIconShieldFill,
  BIconShieldFillCheck,
  BIconShieldFillExclamation,
  BIconShieldFillMinus,
  BIconShieldFillPlus,
  BIconShieldFillX,
  BIconShieldLock,
  BIconShieldLockFill,
  BIconShieldMinus,
  BIconShieldPlus,
  BIconShieldShaded,
  BIconShieldSlash,
  BIconShieldSlashFill,
  BIconShieldX,
  BIconShift,
  BIconShiftFill,
  BIconShop,
  BIconShopWindow,
  BIconShuffle,
  BIconSignDeadEnd,
  BIconSignDeadEndFill,
  BIconSignDoNotEnter,
  BIconSignDoNotEnterFill,
  BIconSignIntersection,
  BIconSignIntersectionFill,
  BIconSignIntersectionSide,
  BIconSignIntersectionSideFill,
  BIconSignIntersectionT,
  BIconSignIntersectionTFill,
  BIconSignIntersectionY,
  BIconSignIntersectionYFill,
  BIconSignMergeLeft,
  BIconSignMergeLeftFill,
  BIconSignMergeRight,
  BIconSignMergeRightFill,
  BIconSignNoLeftTurn,
  BIconSignNoLeftTurnFill,
  BIconSignNoParking,
  BIconSignNoParkingFill,
  BIconSignNoRightTurn,
  BIconSignNoRightTurnFill,
  BIconSignRailroad,
  BIconSignRailroadFill,
  BIconSignStop,
  BIconSignStopFill,
  BIconSignStopLights,
  BIconSignStopLightsFill,
  BIconSignTurnLeft,
  BIconSignTurnLeftFill,
  BIconSignTurnRight,
  BIconSignTurnRightFill,
  BIconSignTurnSlightLeft,
  BIconSignTurnSlightLeftFill,
  BIconSignTurnSlightRight,
  BIconSignTurnSlightRightFill,
  BIconSignYield,
  BIconSignYieldFill,
  BIconSignal,
  BIconSignpost,
  BIconSignpost2,
  BIconSignpost2Fill,
  BIconSignpostFill,
  BIconSignpostSplit,
  BIconSignpostSplitFill,
  BIconSim,
  BIconSimFill,
  BIconSimSlash,
  BIconSimSlashFill,
  BIconSinaWeibo,
  BIconSkipBackward,
  BIconSkipBackwardBtn,
  BIconSkipBackwardBtnFill,
  BIconSkipBackwardCircle,
  BIconSkipBackwardCircleFill,
  BIconSkipBackwardFill,
  BIconSkipEnd,
  BIconSkipEndBtn,
  BIconSkipEndBtnFill,
  BIconSkipEndCircle,
  BIconSkipEndCircleFill,
  BIconSkipEndFill,
  BIconSkipForward,
  BIconSkipForwardBtn,
  BIconSkipForwardBtnFill,
  BIconSkipForwardCircle,
  BIconSkipForwardCircleFill,
  BIconSkipForwardFill,
  BIconSkipStart,
  BIconSkipStartBtn,
  BIconSkipStartBtnFill,
  BIconSkipStartCircle,
  BIconSkipStartCircleFill,
  BIconSkipStartFill,
  BIconSkype,
  BIconSlack,
  BIconSlash,
  BIconSlashCircle,
  BIconSlashCircleFill,
  BIconSlashLg,
  BIconSlashSquare,
  BIconSlashSquareFill,
  BIconSliders,
  BIconSliders2,
  BIconSliders2Vertical,
  BIconSmartwatch,
  BIconSnapchat,
  BIconSnow,
  BIconSnow2,
  BIconSnow3,
  BIconSortAlphaDown,
  BIconSortAlphaDownAlt,
  BIconSortAlphaUp,
  BIconSortAlphaUpAlt,
  BIconSortDown,
  BIconSortDownAlt,
  BIconSortNumericDown,
  BIconSortNumericDownAlt,
  BIconSortNumericUp,
  BIconSortNumericUpAlt,
  BIconSortUp,
  BIconSortUpAlt,
  BIconSoundwave,
  BIconSourceforge,
  BIconSpeaker,
  BIconSpeakerFill,
  BIconSpeedometer,
  BIconSpeedometer2,
  BIconSpellcheck,
  BIconSpotify,
  BIconSquare,
  BIconSquareFill,
  BIconSquareHalf,
  BIconStack,
  BIconStackOverflow,
  BIconStar,
  BIconStarFill,
  BIconStarHalf,
  BIconStars,
  BIconSteam,
  BIconStickies,
  BIconStickiesFill,
  BIconSticky,
  BIconStickyFill,
  BIconStop,
  BIconStopBtn,
  BIconStopBtnFill,
  BIconStopCircle,
  BIconStopCircleFill,
  BIconStopFill,
  BIconStoplights,
  BIconStoplightsFill,
  BIconStopwatch,
  BIconStopwatchFill,
  BIconStrava,
  BIconStripe,
  BIconSubscript,
  BIconSubstack,
  BIconSubtract,
  BIconSuitClub,
  BIconSuitClubFill,
  BIconSuitDiamond,
  BIconSuitDiamondFill,
  BIconSuitHeart,
  BIconSuitHeartFill,
  BIconSuitSpade,
  BIconSuitSpadeFill,
  BIconSuitcase,
  BIconSuitcase2,
  BIconSuitcase2Fill,
  BIconSuitcaseFill,
  BIconSuitcaseLg,
  BIconSuitcaseLgFill,
  BIconSun,
  BIconSunFill,
  BIconSunglasses,
  BIconSunrise,
  BIconSunriseFill,
  BIconSunset,
  BIconSunsetFill,
  BIconSuperscript,
  BIconSymmetryHorizontal,
  BIconSymmetryVertical,
  BIconTable,
  BIconTablet,
  BIconTabletFill,
  BIconTabletLandscape,
  BIconTabletLandscapeFill,
  BIconTag,
  BIconTagFill,
  BIconTags,
  BIconTagsFill,
  BIconTaxiFront,
  BIconTaxiFrontFill,
  BIconTelegram,
  BIconTelephone,
  BIconTelephoneFill,
  BIconTelephoneForward,
  BIconTelephoneForwardFill,
  BIconTelephoneInbound,
  BIconTelephoneInboundFill,
  BIconTelephoneMinus,
  BIconTelephoneMinusFill,
  BIconTelephoneOutbound,
  BIconTelephoneOutboundFill,
  BIconTelephonePlus,
  BIconTelephonePlusFill,
  BIconTelephoneX,
  BIconTelephoneXFill,
  BIconTencentQq,
  BIconTerminal,
  BIconTerminalDash,
  BIconTerminalFill,
  BIconTerminalPlus,
  BIconTerminalSplit,
  BIconTerminalX,
  BIconTextCenter,
  BIconTextIndentLeft,
  BIconTextIndentRight,
  BIconTextLeft,
  BIconTextParagraph,
  BIconTextRight,
  BIconTextWrap,
  BIconTextarea,
  BIconTextareaResize,
  BIconTextareaT,
  BIconThermometer,
  BIconThermometerHalf,
  BIconThermometerHigh,
  BIconThermometerLow,
  BIconThermometerSnow,
  BIconThermometerSun,
  BIconThreads,
  BIconThreadsFill,
  BIconThreeDots,
  BIconThreeDotsVertical,
  BIconThunderbolt,
  BIconThunderboltFill,
  BIconTicket,
  BIconTicketDetailed,
  BIconTicketDetailedFill,
  BIconTicketFill,
  BIconTicketPerforated,
  BIconTicketPerforatedFill,
  BIconTiktok,
  BIconToggle2Off,
  BIconToggle2On,
  BIconToggleOff,
  BIconToggleOn,
  BIconToggles,
  BIconToggles2,
  BIconTools,
  BIconTornado,
  BIconTrainFreightFront,
  BIconTrainFreightFrontFill,
  BIconTrainFront,
  BIconTrainFrontFill,
  BIconTrainLightrailFront,
  BIconTrainLightrailFrontFill,
  BIconTranslate,
  BIconTransparency,
  BIconTrash,
  BIconTrash2,
  BIconTrash2Fill,
  BIconTrash3,
  BIconTrash3Fill,
  BIconTrashFill,
  BIconTree,
  BIconTreeFill,
  BIconTrello,
  BIconTriangle,
  BIconTriangleFill,
  BIconTriangleHalf,
  BIconTrophy,
  BIconTrophyFill,
  BIconTropicalStorm,
  BIconTruck,
  BIconTruckFlatbed,
  BIconTruckFront,
  BIconTruckFrontFill,
  BIconTsunami,
  BIconTv,
  BIconTvFill,
  BIconTwitch,
  BIconTwitter,
  BIconTwitterX,
  BIconType,
  BIconTypeBold,
  BIconTypeH1,
  BIconTypeH2,
  BIconTypeH3,
  BIconTypeH4,
  BIconTypeH5,
  BIconTypeH6,
  BIconTypeItalic,
  BIconTypeStrikethrough,
  BIconTypeUnderline,
  BIconUbuntu,
  BIconUiChecks,
  BIconUiChecksGrid,
  BIconUiRadios,
  BIconUiRadiosGrid,
  BIconUmbrella,
  BIconUmbrellaFill,
  BIconUnindent,
  BIconUnion,
  BIconUnity,
  BIconUniversalAccess,
  BIconUniversalAccessCircle,
  BIconUnlock,
  BIconUnlockFill,
  BIconUpc,
  BIconUpcScan,
  BIconUpload,
  BIconUsb,
  BIconUsbC,
  BIconUsbCFill,
  BIconUsbDrive,
  BIconUsbDriveFill,
  BIconUsbFill,
  BIconUsbMicro,
  BIconUsbMicroFill,
  BIconUsbMini,
  BIconUsbMiniFill,
  BIconUsbPlug,
  BIconUsbPlugFill,
  BIconUsbSymbol,
  BIconValentine,
  BIconValentine2,
  BIconVectorPen,
  BIconViewList,
  BIconViewStacked,
  BIconVignette,
  BIconVimeo,
  BIconVinyl,
  BIconVinylFill,
  BIconVirus,
  BIconVirus2,
  BIconVoicemail,
  BIconVolumeDown,
  BIconVolumeDownFill,
  BIconVolumeMute,
  BIconVolumeMuteFill,
  BIconVolumeOff,
  BIconVolumeOffFill,
  BIconVolumeUp,
  BIconVolumeUpFill,
  BIconVr,
  BIconWallet,
  BIconWallet2,
  BIconWalletFill,
  BIconWatch,
  BIconWater,
  BIconWebcam,
  BIconWebcamFill,
  BIconWechat,
  BIconWhatsapp,
  BIconWifi,
  BIconWifi1,
  BIconWifi2,
  BIconWifiOff,
  BIconWikipedia,
  BIconWind,
  BIconWindow,
  BIconWindowDash,
  BIconWindowDesktop,
  BIconWindowDock,
  BIconWindowFullscreen,
  BIconWindowPlus,
  BIconWindowSidebar,
  BIconWindowSplit,
  BIconWindowStack,
  BIconWindowX,
  BIconWindows,
  BIconWordpress,
  BIconWrench,
  BIconWrenchAdjustable,
  BIconWrenchAdjustableCircle,
  BIconWrenchAdjustableCircleFill,
  BIconX,
  BIconXCircle,
  BIconXCircleFill,
  BIconXDiamond,
  BIconXDiamondFill,
  BIconXLg,
  BIconXOctagon,
  BIconXOctagonFill,
  BIconXSquare,
  BIconXSquareFill,
  BIconXbox,
  BIconYelp,
  BIconYinYang,
  BIconYoutube,
  BIconZoomIn,
  BIconZoomOut
} from './icons'

// Icon component names for used in the docs
export const iconNames = [
  // BootstrapVue custom icon component names
  'BIconBlank',
  // Bootstrap icon component names
  'BIcon0Circle',
  'BIcon0CircleFill',
  'BIcon0Square',
  'BIcon0SquareFill',
  'BIcon123',
  'BIcon1Circle',
  'BIcon1CircleFill',
  'BIcon1Square',
  'BIcon1SquareFill',
  'BIcon2Circle',
  'BIcon2CircleFill',
  'BIcon2Square',
  'BIcon2SquareFill',
  'BIcon3Circle',
  'BIcon3CircleFill',
  'BIcon3Square',
  'BIcon3SquareFill',
  'BIcon4Circle',
  'BIcon4CircleFill',
  'BIcon4Square',
  'BIcon4SquareFill',
  'BIcon5Circle',
  'BIcon5CircleFill',
  'BIcon5Square',
  'BIcon5SquareFill',
  'BIcon6Circle',
  'BIcon6CircleFill',
  'BIcon6Square',
  'BIcon6SquareFill',
  'BIcon7Circle',
  'BIcon7CircleFill',
  'BIcon7Square',
  'BIcon7SquareFill',
  'BIcon8Circle',
  'BIcon8CircleFill',
  'BIcon8Square',
  'BIcon8SquareFill',
  'BIcon9Circle',
  'BIcon9CircleFill',
  'BIcon9Square',
  'BIcon9SquareFill',
  'BIconActivity',
  'BIconAirplane',
  'BIconAirplaneEngines',
  'BIconAirplaneEnginesFill',
  'BIconAirplaneFill',
  'BIconAlarm',
  'BIconAlarmFill',
  'BIconAlexa',
  'BIconAlignBottom',
  'BIconAlignCenter',
  'BIconAlignEnd',
  'BIconAlignMiddle',
  'BIconAlignStart',
  'BIconAlignTop',
  'BIconAlipay',
  'BIconAlphabet',
  'BIconAlphabetUppercase',
  'BIconAlt',
  'BIconAmazon',
  'BIconAmd',
  'BIconAndroid',
  'BIconAndroid2',
  'BIconApp',
  'BIconAppIndicator',
  'BIconApple',
  'BIconArchive',
  'BIconArchiveFill',
  'BIconArrow90degDown',
  'BIconArrow90degLeft',
  'BIconArrow90degRight',
  'BIconArrow90degUp',
  'BIconArrowBarDown',
  'BIconArrowBarLeft',
  'BIconArrowBarRight',
  'BIconArrowBarUp',
  'BIconArrowClockwise',
  'BIconArrowCounterclockwise',
  'BIconArrowDown',
  'BIconArrowDownCircle',
  'BIconArrowDownCircleFill',
  'BIconArrowDownLeft',
  'BIconArrowDownLeftCircle',
  'BIconArrowDownLeftCircleFill',
  'BIconArrowDownLeftSquare',
  'BIconArrowDownLeftSquareFill',
  'BIconArrowDownRight',
  'BIconArrowDownRightCircle',
  'BIconArrowDownRightCircleFill',
  'BIconArrowDownRightSquare',
  'BIconArrowDownRightSquareFill',
  'BIconArrowDownShort',
  'BIconArrowDownSquare',
  'BIconArrowDownSquareFill',
  'BIconArrowDownUp',
  'BIconArrowLeft',
  'BIconArrowLeftCircle',
  'BIconArrowLeftCircleFill',
  'BIconArrowLeftRight',
  'BIconArrowLeftShort',
  'BIconArrowLeftSquare',
  'BIconArrowLeftSquareFill',
  'BIconArrowRepeat',
  'BIconArrowReturnLeft',
  'BIconArrowReturnRight',
  'BIconArrowRight',
  'BIconArrowRightCircle',
  'BIconArrowRightCircleFill',
  'BIconArrowRightShort',
  'BIconArrowRightSquare',
  'BIconArrowRightSquareFill',
  'BIconArrowThroughHeart',
  'BIconArrowThroughHeartFill',
  'BIconArrowUp',
  'BIconArrowUpCircle',
  'BIconArrowUpCircleFill',
  'BIconArrowUpLeft',
  'BIconArrowUpLeftCircle',
  'BIconArrowUpLeftCircleFill',
  'BIconArrowUpLeftSquare',
  'BIconArrowUpLeftSquareFill',
  'BIconArrowUpRight',
  'BIconArrowUpRightCircle',
  'BIconArrowUpRightCircleFill',
  'BIconArrowUpRightSquare',
  'BIconArrowUpRightSquareFill',
  'BIconArrowUpShort',
  'BIconArrowUpSquare',
  'BIconArrowUpSquareFill',
  'BIconArrows',
  'BIconArrowsAngleContract',
  'BIconArrowsAngleExpand',
  'BIconArrowsCollapse',
  'BIconArrowsCollapseVertical',
  'BIconArrowsExpand',
  'BIconArrowsExpandVertical',
  'BIconArrowsFullscreen',
  'BIconArrowsMove',
  'BIconArrowsVertical',
  'BIconAspectRatio',
  'BIconAspectRatioFill',
  'BIconAsterisk',
  'BIconAt',
  'BIconAward',
  'BIconAwardFill',
  'BIconBack',
  'BIconBackpack',
  'BIconBackpack2',
  'BIconBackpack2Fill',
  'BIconBackpack3',
  'BIconBackpack3Fill',
  'BIconBackpack4',
  'BIconBackpack4Fill',
  'BIconBackpackFill',
  'BIconBackspace',
  'BIconBackspaceFill',
  'BIconBackspaceReverse',
  'BIconBackspaceReverseFill',
  'BIconBadge3d',
  'BIconBadge3dFill',
  'BIconBadge4k',
  'BIconBadge4kFill',
  'BIconBadge8k',
  'BIconBadge8kFill',
  'BIconBadgeAd',
  'BIconBadgeAdFill',
  'BIconBadgeAr',
  'BIconBadgeArFill',
  'BIconBadgeCc',
  'BIconBadgeCcFill',
  'BIconBadgeHd',
  'BIconBadgeHdFill',
  'BIconBadgeSd',
  'BIconBadgeSdFill',
  'BIconBadgeTm',
  'BIconBadgeTmFill',
  'BIconBadgeVo',
  'BIconBadgeVoFill',
  'BIconBadgeVr',
  'BIconBadgeVrFill',
  'BIconBadgeWc',
  'BIconBadgeWcFill',
  'BIconBag',
  'BIconBagCheck',
  'BIconBagCheckFill',
  'BIconBagDash',
  'BIconBagDashFill',
  'BIconBagFill',
  'BIconBagHeart',
  'BIconBagHeartFill',
  'BIconBagPlus',
  'BIconBagPlusFill',
  'BIconBagX',
  'BIconBagXFill',
  'BIconBalloon',
  'BIconBalloonFill',
  'BIconBalloonHeart',
  'BIconBalloonHeartFill',
  'BIconBan',
  'BIconBanFill',
  'BIconBandaid',
  'BIconBandaidFill',
  'BIconBank',
  'BIconBank2',
  'BIconBarChart',
  'BIconBarChartFill',
  'BIconBarChartLine',
  'BIconBarChartLineFill',
  'BIconBarChartSteps',
  'BIconBasket',
  'BIconBasket2',
  'BIconBasket2Fill',
  'BIconBasket3',
  'BIconBasket3Fill',
  'BIconBasketFill',
  'BIconBattery',
  'BIconBatteryCharging',
  'BIconBatteryFull',
  'BIconBatteryHalf',
  'BIconBehance',
  'BIconBell',
  'BIconBellFill',
  'BIconBellSlash',
  'BIconBellSlashFill',
  'BIconBezier',
  'BIconBezier2',
  'BIconBicycle',
  'BIconBing',
  'BIconBinoculars',
  'BIconBinocularsFill',
  'BIconBlockquoteLeft',
  'BIconBlockquoteRight',
  'BIconBluetooth',
  'BIconBodyText',
  'BIconBook',
  'BIconBookFill',
  'BIconBookHalf',
  'BIconBookmark',
  'BIconBookmarkCheck',
  'BIconBookmarkCheckFill',
  'BIconBookmarkDash',
  'BIconBookmarkDashFill',
  'BIconBookmarkFill',
  'BIconBookmarkHeart',
  'BIconBookmarkHeartFill',
  'BIconBookmarkPlus',
  'BIconBookmarkPlusFill',
  'BIconBookmarkStar',
  'BIconBookmarkStarFill',
  'BIconBookmarkX',
  'BIconBookmarkXFill',
  'BIconBookmarks',
  'BIconBookmarksFill',
  'BIconBookshelf',
  'BIconBoombox',
  'BIconBoomboxFill',
  'BIconBootstrap',
  'BIconBootstrapFill',
  'BIconBootstrapReboot',
  'BIconBorder',
  'BIconBorderAll',
  'BIconBorderBottom',
  'BIconBorderCenter',
  'BIconBorderInner',
  'BIconBorderLeft',
  'BIconBorderMiddle',
  'BIconBorderOuter',
  'BIconBorderRight',
  'BIconBorderStyle',
  'BIconBorderTop',
  'BIconBorderWidth',
  'BIconBoundingBox',
  'BIconBoundingBoxCircles',
  'BIconBox',
  'BIconBox2',
  'BIconBox2Fill',
  'BIconBox2Heart',
  'BIconBox2HeartFill',
  'BIconBoxArrowDown',
  'BIconBoxArrowDownLeft',
  'BIconBoxArrowDownRight',
  'BIconBoxArrowInDown',
  'BIconBoxArrowInDownLeft',
  'BIconBoxArrowInDownRight',
  'BIconBoxArrowInLeft',
  'BIconBoxArrowInRight',
  'BIconBoxArrowInUp',
  'BIconBoxArrowInUpLeft',
  'BIconBoxArrowInUpRight',
  'BIconBoxArrowLeft',
  'BIconBoxArrowRight',
  'BIconBoxArrowUp',
  'BIconBoxArrowUpLeft',
  'BIconBoxArrowUpRight',
  'BIconBoxFill',
  'BIconBoxSeam',
  'BIconBoxSeamFill',
  'BIconBoxes',
  'BIconBraces',
  'BIconBracesAsterisk',
  'BIconBricks',
  'BIconBriefcase',
  'BIconBriefcaseFill',
  'BIconBrightnessAltHigh',
  'BIconBrightnessAltHighFill',
  'BIconBrightnessAltLow',
  'BIconBrightnessAltLowFill',
  'BIconBrightnessHigh',
  'BIconBrightnessHighFill',
  'BIconBrightnessLow',
  'BIconBrightnessLowFill',
  'BIconBrilliance',
  'BIconBroadcast',
  'BIconBroadcastPin',
  'BIconBrowserChrome',
  'BIconBrowserEdge',
  'BIconBrowserFirefox',
  'BIconBrowserSafari',
  'BIconBrush',
  'BIconBrushFill',
  'BIconBucket',
  'BIconBucketFill',
  'BIconBug',
  'BIconBugFill',
  'BIconBuilding',
  'BIconBuildingAdd',
  'BIconBuildingCheck',
  'BIconBuildingDash',
  'BIconBuildingDown',
  'BIconBuildingExclamation',
  'BIconBuildingFill',
  'BIconBuildingFillAdd',
  'BIconBuildingFillCheck',
  'BIconBuildingFillDash',
  'BIconBuildingFillDown',
  'BIconBuildingFillExclamation',
  'BIconBuildingFillGear',
  'BIconBuildingFillLock',
  'BIconBuildingFillSlash',
  'BIconBuildingFillUp',
  'BIconBuildingFillX',
  'BIconBuildingGear',
  'BIconBuildingLock',
  'BIconBuildingSlash',
  'BIconBuildingUp',
  'BIconBuildingX',
  'BIconBuildings',
  'BIconBuildingsFill',
  'BIconBullseye',
  'BIconBusFront',
  'BIconBusFrontFill',
  'BIconCCircle',
  'BIconCCircleFill',
  'BIconCSquare',
  'BIconCSquareFill',
  'BIconCake',
  'BIconCake2',
  'BIconCake2Fill',
  'BIconCakeFill',
  'BIconCalculator',
  'BIconCalculatorFill',
  'BIconCalendar',
  'BIconCalendar2',
  'BIconCalendar2Check',
  'BIconCalendar2CheckFill',
  'BIconCalendar2Date',
  'BIconCalendar2DateFill',
  'BIconCalendar2Day',
  'BIconCalendar2DayFill',
  'BIconCalendar2Event',
  'BIconCalendar2EventFill',
  'BIconCalendar2Fill',
  'BIconCalendar2Heart',
  'BIconCalendar2HeartFill',
  'BIconCalendar2Minus',
  'BIconCalendar2MinusFill',
  'BIconCalendar2Month',
  'BIconCalendar2MonthFill',
  'BIconCalendar2Plus',
  'BIconCalendar2PlusFill',
  'BIconCalendar2Range',
  'BIconCalendar2RangeFill',
  'BIconCalendar2Week',
  'BIconCalendar2WeekFill',
  'BIconCalendar2X',
  'BIconCalendar2XFill',
  'BIconCalendar3',
  'BIconCalendar3Event',
  'BIconCalendar3EventFill',
  'BIconCalendar3Fill',
  'BIconCalendar3Range',
  'BIconCalendar3RangeFill',
  'BIconCalendar3Week',
  'BIconCalendar3WeekFill',
  'BIconCalendar4',
  'BIconCalendar4Event',
  'BIconCalendar4Range',
  'BIconCalendar4Week',
  'BIconCalendarCheck',
  'BIconCalendarCheckFill',
  'BIconCalendarDate',
  'BIconCalendarDateFill',
  'BIconCalendarDay',
  'BIconCalendarDayFill',
  'BIconCalendarEvent',
  'BIconCalendarEventFill',
  'BIconCalendarFill',
  'BIconCalendarHeart',
  'BIconCalendarHeartFill',
  'BIconCalendarMinus',
  'BIconCalendarMinusFill',
  'BIconCalendarMonth',
  'BIconCalendarMonthFill',
  'BIconCalendarPlus',
  'BIconCalendarPlusFill',
  'BIconCalendarRange',
  'BIconCalendarRangeFill',
  'BIconCalendarWeek',
  'BIconCalendarWeekFill',
  'BIconCalendarX',
  'BIconCalendarXFill',
  'BIconCamera',
  'BIconCamera2',
  'BIconCameraFill',
  'BIconCameraReels',
  'BIconCameraReelsFill',
  'BIconCameraVideo',
  'BIconCameraVideoFill',
  'BIconCameraVideoOff',
  'BIconCameraVideoOffFill',
  'BIconCapslock',
  'BIconCapslockFill',
  'BIconCapsule',
  'BIconCapsulePill',
  'BIconCarFront',
  'BIconCarFrontFill',
  'BIconCardChecklist',
  'BIconCardHeading',
  'BIconCardImage',
  'BIconCardList',
  'BIconCardText',
  'BIconCaretDown',
  'BIconCaretDownFill',
  'BIconCaretDownSquare',
  'BIconCaretDownSquareFill',
  'BIconCaretLeft',
  'BIconCaretLeftFill',
  'BIconCaretLeftSquare',
  'BIconCaretLeftSquareFill',
  'BIconCaretRight',
  'BIconCaretRightFill',
  'BIconCaretRightSquare',
  'BIconCaretRightSquareFill',
  'BIconCaretUp',
  'BIconCaretUpFill',
  'BIconCaretUpSquare',
  'BIconCaretUpSquareFill',
  'BIconCart',
  'BIconCart2',
  'BIconCart3',
  'BIconCart4',
  'BIconCartCheck',
  'BIconCartCheckFill',
  'BIconCartDash',
  'BIconCartDashFill',
  'BIconCartFill',
  'BIconCartPlus',
  'BIconCartPlusFill',
  'BIconCartX',
  'BIconCartXFill',
  'BIconCash',
  'BIconCashCoin',
  'BIconCashStack',
  'BIconCassette',
  'BIconCassetteFill',
  'BIconCast',
  'BIconCcCircle',
  'BIconCcCircleFill',
  'BIconCcSquare',
  'BIconCcSquareFill',
  'BIconChat',
  'BIconChatDots',
  'BIconChatDotsFill',
  'BIconChatFill',
  'BIconChatHeart',
  'BIconChatHeartFill',
  'BIconChatLeft',
  'BIconChatLeftDots',
  'BIconChatLeftDotsFill',
  'BIconChatLeftFill',
  'BIconChatLeftHeart',
  'BIconChatLeftHeartFill',
  'BIconChatLeftQuote',
  'BIconChatLeftQuoteFill',
  'BIconChatLeftText',
  'BIconChatLeftTextFill',
  'BIconChatQuote',
  'BIconChatQuoteFill',
  'BIconChatRight',
  'BIconChatRightDots',
  'BIconChatRightDotsFill',
  'BIconChatRightFill',
  'BIconChatRightHeart',
  'BIconChatRightHeartFill',
  'BIconChatRightQuote',
  'BIconChatRightQuoteFill',
  'BIconChatRightText',
  'BIconChatRightTextFill',
  'BIconChatSquare',
  'BIconChatSquareDots',
  'BIconChatSquareDotsFill',
  'BIconChatSquareFill',
  'BIconChatSquareHeart',
  'BIconChatSquareHeartFill',
  'BIconChatSquareQuote',
  'BIconChatSquareQuoteFill',
  'BIconChatSquareText',
  'BIconChatSquareTextFill',
  'BIconChatText',
  'BIconChatTextFill',
  'BIconCheck',
  'BIconCheck2',
  'BIconCheck2All',
  'BIconCheck2Circle',
  'BIconCheck2Square',
  'BIconCheckAll',
  'BIconCheckCircle',
  'BIconCheckCircleFill',
  'BIconCheckLg',
  'BIconCheckSquare',
  'BIconCheckSquareFill',
  'BIconChevronBarContract',
  'BIconChevronBarDown',
  'BIconChevronBarExpand',
  'BIconChevronBarLeft',
  'BIconChevronBarRight',
  'BIconChevronBarUp',
  'BIconChevronCompactDown',
  'BIconChevronCompactLeft',
  'BIconChevronCompactRight',
  'BIconChevronCompactUp',
  'BIconChevronContract',
  'BIconChevronDoubleDown',
  'BIconChevronDoubleLeft',
  'BIconChevronDoubleRight',
  'BIconChevronDoubleUp',
  'BIconChevronDown',
  'BIconChevronExpand',
  'BIconChevronLeft',
  'BIconChevronRight',
  'BIconChevronUp',
  'BIconCircle',
  'BIconCircleFill',
  'BIconCircleHalf',
  'BIconCircleSquare',
  'BIconClipboard',
  'BIconClipboard2',
  'BIconClipboard2Check',
  'BIconClipboard2CheckFill',
  'BIconClipboard2Data',
  'BIconClipboard2DataFill',
  'BIconClipboard2Fill',
  'BIconClipboard2Heart',
  'BIconClipboard2HeartFill',
  'BIconClipboard2Minus',
  'BIconClipboard2MinusFill',
  'BIconClipboard2Plus',
  'BIconClipboard2PlusFill',
  'BIconClipboard2Pulse',
  'BIconClipboard2PulseFill',
  'BIconClipboard2X',
  'BIconClipboard2XFill',
  'BIconClipboardCheck',
  'BIconClipboardCheckFill',
  'BIconClipboardData',
  'BIconClipboardDataFill',
  'BIconClipboardFill',
  'BIconClipboardHeart',
  'BIconClipboardHeartFill',
  'BIconClipboardMinus',
  'BIconClipboardMinusFill',
  'BIconClipboardPlus',
  'BIconClipboardPlusFill',
  'BIconClipboardPulse',
  'BIconClipboardX',
  'BIconClipboardXFill',
  'BIconClock',
  'BIconClockFill',
  'BIconClockHistory',
  'BIconCloud',
  'BIconCloudArrowDown',
  'BIconCloudArrowDownFill',
  'BIconCloudArrowUp',
  'BIconCloudArrowUpFill',
  'BIconCloudCheck',
  'BIconCloudCheckFill',
  'BIconCloudDownload',
  'BIconCloudDownloadFill',
  'BIconCloudDrizzle',
  'BIconCloudDrizzleFill',
  'BIconCloudFill',
  'BIconCloudFog',
  'BIconCloudFog2',
  'BIconCloudFog2Fill',
  'BIconCloudFogFill',
  'BIconCloudHail',
  'BIconCloudHailFill',
  'BIconCloudHaze',
  'BIconCloudHaze2',
  'BIconCloudHaze2Fill',
  'BIconCloudHazeFill',
  'BIconCloudLightning',
  'BIconCloudLightningFill',
  'BIconCloudLightningRain',
  'BIconCloudLightningRainFill',
  'BIconCloudMinus',
  'BIconCloudMinusFill',
  'BIconCloudMoon',
  'BIconCloudMoonFill',
  'BIconCloudPlus',
  'BIconCloudPlusFill',
  'BIconCloudRain',
  'BIconCloudRainFill',
  'BIconCloudRainHeavy',
  'BIconCloudRainHeavyFill',
  'BIconCloudSlash',
  'BIconCloudSlashFill',
  'BIconCloudSleet',
  'BIconCloudSleetFill',
  'BIconCloudSnow',
  'BIconCloudSnowFill',
  'BIconCloudSun',
  'BIconCloudSunFill',
  'BIconCloudUpload',
  'BIconCloudUploadFill',
  'BIconClouds',
  'BIconCloudsFill',
  'BIconCloudy',
  'BIconCloudyFill',
  'BIconCode',
  'BIconCodeSlash',
  'BIconCodeSquare',
  'BIconCoin',
  'BIconCollection',
  'BIconCollectionFill',
  'BIconCollectionPlay',
  'BIconCollectionPlayFill',
  'BIconColumns',
  'BIconColumnsGap',
  'BIconCommand',
  'BIconCompass',
  'BIconCompassFill',
  'BIconCone',
  'BIconConeStriped',
  'BIconController',
  'BIconCookie',
  'BIconCopy',
  'BIconCpu',
  'BIconCpuFill',
  'BIconCreditCard',
  'BIconCreditCard2Back',
  'BIconCreditCard2BackFill',
  'BIconCreditCard2Front',
  'BIconCreditCard2FrontFill',
  'BIconCreditCardFill',
  'BIconCrop',
  'BIconCrosshair',
  'BIconCrosshair2',
  'BIconCup',
  'BIconCupFill',
  'BIconCupHot',
  'BIconCupHotFill',
  'BIconCupStraw',
  'BIconCurrencyBitcoin',
  'BIconCurrencyDollar',
  'BIconCurrencyEuro',
  'BIconCurrencyExchange',
  'BIconCurrencyPound',
  'BIconCurrencyRupee',
  'BIconCurrencyYen',
  'BIconCursor',
  'BIconCursorFill',
  'BIconCursorText',
  'BIconDash',
  'BIconDashCircle',
  'BIconDashCircleDotted',
  'BIconDashCircleFill',
  'BIconDashLg',
  'BIconDashSquare',
  'BIconDashSquareDotted',
  'BIconDashSquareFill',
  'BIconDatabase',
  'BIconDatabaseAdd',
  'BIconDatabaseCheck',
  'BIconDatabaseDash',
  'BIconDatabaseDown',
  'BIconDatabaseExclamation',
  'BIconDatabaseFill',
  'BIconDatabaseFillAdd',
  'BIconDatabaseFillCheck',
  'BIconDatabaseFillDash',
  'BIconDatabaseFillDown',
  'BIconDatabaseFillExclamation',
  'BIconDatabaseFillGear',
  'BIconDatabaseFillLock',
  'BIconDatabaseFillSlash',
  'BIconDatabaseFillUp',
  'BIconDatabaseFillX',
  'BIconDatabaseGear',
  'BIconDatabaseLock',
  'BIconDatabaseSlash',
  'BIconDatabaseUp',
  'BIconDatabaseX',
  'BIconDeviceHdd',
  'BIconDeviceHddFill',
  'BIconDeviceSsd',
  'BIconDeviceSsdFill',
  'BIconDiagram2',
  'BIconDiagram2Fill',
  'BIconDiagram3',
  'BIconDiagram3Fill',
  'BIconDiamond',
  'BIconDiamondFill',
  'BIconDiamondHalf',
  'BIconDice1',
  'BIconDice1Fill',
  'BIconDice2',
  'BIconDice2Fill',
  'BIconDice3',
  'BIconDice3Fill',
  'BIconDice4',
  'BIconDice4Fill',
  'BIconDice5',
  'BIconDice5Fill',
  'BIconDice6',
  'BIconDice6Fill',
  'BIconDisc',
  'BIconDiscFill',
  'BIconDiscord',
  'BIconDisplay',
  'BIconDisplayFill',
  'BIconDisplayport',
  'BIconDisplayportFill',
  'BIconDistributeHorizontal',
  'BIconDistributeVertical',
  'BIconDoorClosed',
  'BIconDoorClosedFill',
  'BIconDoorOpen',
  'BIconDoorOpenFill',
  'BIconDot',
  'BIconDownload',
  'BIconDpad',
  'BIconDpadFill',
  'BIconDribbble',
  'BIconDropbox',
  'BIconDroplet',
  'BIconDropletFill',
  'BIconDropletHalf',
  'BIconDuffle',
  'BIconDuffleFill',
  'BIconEar',
  'BIconEarFill',
  'BIconEarbuds',
  'BIconEasel',
  'BIconEasel2',
  'BIconEasel2Fill',
  'BIconEasel3',
  'BIconEasel3Fill',
  'BIconEaselFill',
  'BIconEgg',
  'BIconEggFill',
  'BIconEggFried',
  'BIconEject',
  'BIconEjectFill',
  'BIconEmojiAngry',
  'BIconEmojiAngryFill',
  'BIconEmojiAstonished',
  'BIconEmojiAstonishedFill',
  'BIconEmojiDizzy',
  'BIconEmojiDizzyFill',
  'BIconEmojiExpressionless',
  'BIconEmojiExpressionlessFill',
  'BIconEmojiFrown',
  'BIconEmojiFrownFill',
  'BIconEmojiGrimace',
  'BIconEmojiGrimaceFill',
  'BIconEmojiGrin',
  'BIconEmojiGrinFill',
  'BIconEmojiHeartEyes',
  'BIconEmojiHeartEyesFill',
  'BIconEmojiKiss',
  'BIconEmojiKissFill',
  'BIconEmojiLaughing',
  'BIconEmojiLaughingFill',
  'BIconEmojiNeutral',
  'BIconEmojiNeutralFill',
  'BIconEmojiSmile',
  'BIconEmojiSmileFill',
  'BIconEmojiSmileUpsideDown',
  'BIconEmojiSmileUpsideDownFill',
  'BIconEmojiSunglasses',
  'BIconEmojiSunglassesFill',
  'BIconEmojiSurprise',
  'BIconEmojiSurpriseFill',
  'BIconEmojiTear',
  'BIconEmojiTearFill',
  'BIconEmojiWink',
  'BIconEmojiWinkFill',
  'BIconEnvelope',
  'BIconEnvelopeArrowDown',
  'BIconEnvelopeArrowDownFill',
  'BIconEnvelopeArrowUp',
  'BIconEnvelopeArrowUpFill',
  'BIconEnvelopeAt',
  'BIconEnvelopeAtFill',
  'BIconEnvelopeCheck',
  'BIconEnvelopeCheckFill',
  'BIconEnvelopeDash',
  'BIconEnvelopeDashFill',
  'BIconEnvelopeExclamation',
  'BIconEnvelopeExclamationFill',
  'BIconEnvelopeFill',
  'BIconEnvelopeHeart',
  'BIconEnvelopeHeartFill',
  'BIconEnvelopeOpen',
  'BIconEnvelopeOpenFill',
  'BIconEnvelopeOpenHeart',
  'BIconEnvelopeOpenHeartFill',
  'BIconEnvelopePaper',
  'BIconEnvelopePaperFill',
  'BIconEnvelopePaperHeart',
  'BIconEnvelopePaperHeartFill',
  'BIconEnvelopePlus',
  'BIconEnvelopePlusFill',
  'BIconEnvelopeSlash',
  'BIconEnvelopeSlashFill',
  'BIconEnvelopeX',
  'BIconEnvelopeXFill',
  'BIconEraser',
  'BIconEraserFill',
  'BIconEscape',
  'BIconEthernet',
  'BIconEvFront',
  'BIconEvFrontFill',
  'BIconEvStation',
  'BIconEvStationFill',
  'BIconExclamation',
  'BIconExclamationCircle',
  'BIconExclamationCircleFill',
  'BIconExclamationDiamond',
  'BIconExclamationDiamondFill',
  'BIconExclamationLg',
  'BIconExclamationOctagon',
  'BIconExclamationOctagonFill',
  'BIconExclamationSquare',
  'BIconExclamationSquareFill',
  'BIconExclamationTriangle',
  'BIconExclamationTriangleFill',
  'BIconExclude',
  'BIconExplicit',
  'BIconExplicitFill',
  'BIconExposure',
  'BIconEye',
  'BIconEyeFill',
  'BIconEyeSlash',
  'BIconEyeSlashFill',
  'BIconEyedropper',
  'BIconEyeglasses',
  'BIconFacebook',
  'BIconFan',
  'BIconFastForward',
  'BIconFastForwardBtn',
  'BIconFastForwardBtnFill',
  'BIconFastForwardCircle',
  'BIconFastForwardCircleFill',
  'BIconFastForwardFill',
  'BIconFeather',
  'BIconFeather2',
  'BIconFile',
  'BIconFileArrowDown',
  'BIconFileArrowDownFill',
  'BIconFileArrowUp',
  'BIconFileArrowUpFill',
  'BIconFileBarGraph',
  'BIconFileBarGraphFill',
  'BIconFileBinary',
  'BIconFileBinaryFill',
  'BIconFileBreak',
  'BIconFileBreakFill',
  'BIconFileCheck',
  'BIconFileCheckFill',
  'BIconFileCode',
  'BIconFileCodeFill',
  'BIconFileDiff',
  'BIconFileDiffFill',
  'BIconFileEarmark',
  'BIconFileEarmarkArrowDown',
  'BIconFileEarmarkArrowDownFill',
  'BIconFileEarmarkArrowUp',
  'BIconFileEarmarkArrowUpFill',
  'BIconFileEarmarkBarGraph',
  'BIconFileEarmarkBarGraphFill',
  'BIconFileEarmarkBinary',
  'BIconFileEarmarkBinaryFill',
  'BIconFileEarmarkBreak',
  'BIconFileEarmarkBreakFill',
  'BIconFileEarmarkCheck',
  'BIconFileEarmarkCheckFill',
  'BIconFileEarmarkCode',
  'BIconFileEarmarkCodeFill',
  'BIconFileEarmarkDiff',
  'BIconFileEarmarkDiffFill',
  'BIconFileEarmarkEasel',
  'BIconFileEarmarkEaselFill',
  'BIconFileEarmarkExcel',
  'BIconFileEarmarkExcelFill',
  'BIconFileEarmarkFill',
  'BIconFileEarmarkFont',
  'BIconFileEarmarkFontFill',
  'BIconFileEarmarkImage',
  'BIconFileEarmarkImageFill',
  'BIconFileEarmarkLock',
  'BIconFileEarmarkLock2',
  'BIconFileEarmarkLock2Fill',
  'BIconFileEarmarkLockFill',
  'BIconFileEarmarkMedical',
  'BIconFileEarmarkMedicalFill',
  'BIconFileEarmarkMinus',
  'BIconFileEarmarkMinusFill',
  'BIconFileEarmarkMusic',
  'BIconFileEarmarkMusicFill',
  'BIconFileEarmarkPdf',
  'BIconFileEarmarkPdfFill',
  'BIconFileEarmarkPerson',
  'BIconFileEarmarkPersonFill',
  'BIconFileEarmarkPlay',
  'BIconFileEarmarkPlayFill',
  'BIconFileEarmarkPlus',
  'BIconFileEarmarkPlusFill',
  'BIconFileEarmarkPost',
  'BIconFileEarmarkPostFill',
  'BIconFileEarmarkPpt',
  'BIconFileEarmarkPptFill',
  'BIconFileEarmarkRichtext',
  'BIconFileEarmarkRichtextFill',
  'BIconFileEarmarkRuled',
  'BIconFileEarmarkRuledFill',
  'BIconFileEarmarkSlides',
  'BIconFileEarmarkSlidesFill',
  'BIconFileEarmarkSpreadsheet',
  'BIconFileEarmarkSpreadsheetFill',
  'BIconFileEarmarkText',
  'BIconFileEarmarkTextFill',
  'BIconFileEarmarkWord',
  'BIconFileEarmarkWordFill',
  'BIconFileEarmarkX',
  'BIconFileEarmarkXFill',
  'BIconFileEarmarkZip',
  'BIconFileEarmarkZipFill',
  'BIconFileEasel',
  'BIconFileEaselFill',
  'BIconFileExcel',
  'BIconFileExcelFill',
  'BIconFileFill',
  'BIconFileFont',
  'BIconFileFontFill',
  'BIconFileImage',
  'BIconFileImageFill',
  'BIconFileLock',
  'BIconFileLock2',
  'BIconFileLock2Fill',
  'BIconFileLockFill',
  'BIconFileMedical',
  'BIconFileMedicalFill',
  'BIconFileMinus',
  'BIconFileMinusFill',
  'BIconFileMusic',
  'BIconFileMusicFill',
  'BIconFilePdf',
  'BIconFilePdfFill',
  'BIconFilePerson',
  'BIconFilePersonFill',
  'BIconFilePlay',
  'BIconFilePlayFill',
  'BIconFilePlus',
  'BIconFilePlusFill',
  'BIconFilePost',
  'BIconFilePostFill',
  'BIconFilePpt',
  'BIconFilePptFill',
  'BIconFileRichtext',
  'BIconFileRichtextFill',
  'BIconFileRuled',
  'BIconFileRuledFill',
  'BIconFileSlides',
  'BIconFileSlidesFill',
  'BIconFileSpreadsheet',
  'BIconFileSpreadsheetFill',
  'BIconFileText',
  'BIconFileTextFill',
  'BIconFileWord',
  'BIconFileWordFill',
  'BIconFileX',
  'BIconFileXFill',
  'BIconFileZip',
  'BIconFileZipFill',
  'BIconFiles',
  'BIconFilesAlt',
  'BIconFiletypeAac',
  'BIconFiletypeAi',
  'BIconFiletypeBmp',
  'BIconFiletypeCs',
  'BIconFiletypeCss',
  'BIconFiletypeCsv',
  'BIconFiletypeDoc',
  'BIconFiletypeDocx',
  'BIconFiletypeExe',
  'BIconFiletypeGif',
  'BIconFiletypeHeic',
  'BIconFiletypeHtml',
  'BIconFiletypeJava',
  'BIconFiletypeJpg',
  'BIconFiletypeJs',
  'BIconFiletypeJson',
  'BIconFiletypeJsx',
  'BIconFiletypeKey',
  'BIconFiletypeM4p',
  'BIconFiletypeMd',
  'BIconFiletypeMdx',
  'BIconFiletypeMov',
  'BIconFiletypeMp3',
  'BIconFiletypeMp4',
  'BIconFiletypeOtf',
  'BIconFiletypePdf',
  'BIconFiletypePhp',
  'BIconFiletypePng',
  'BIconFiletypePpt',
  'BIconFiletypePptx',
  'BIconFiletypePsd',
  'BIconFiletypePy',
  'BIconFiletypeRaw',
  'BIconFiletypeRb',
  'BIconFiletypeSass',
  'BIconFiletypeScss',
  'BIconFiletypeSh',
  'BIconFiletypeSql',
  'BIconFiletypeSvg',
  'BIconFiletypeTiff',
  'BIconFiletypeTsx',
  'BIconFiletypeTtf',
  'BIconFiletypeTxt',
  'BIconFiletypeWav',
  'BIconFiletypeWoff',
  'BIconFiletypeXls',
  'BIconFiletypeXlsx',
  'BIconFiletypeXml',
  'BIconFiletypeYml',
  'BIconFilm',
  'BIconFilter',
  'BIconFilterCircle',
  'BIconFilterCircleFill',
  'BIconFilterLeft',
  'BIconFilterRight',
  'BIconFilterSquare',
  'BIconFilterSquareFill',
  'BIconFingerprint',
  'BIconFire',
  'BIconFlag',
  'BIconFlagFill',
  'BIconFloppy',
  'BIconFloppy2',
  'BIconFloppy2Fill',
  'BIconFloppyFill',
  'BIconFlower1',
  'BIconFlower2',
  'BIconFlower3',
  'BIconFolder',
  'BIconFolder2',
  'BIconFolder2Open',
  'BIconFolderCheck',
  'BIconFolderFill',
  'BIconFolderMinus',
  'BIconFolderPlus',
  'BIconFolderSymlink',
  'BIconFolderSymlinkFill',
  'BIconFolderX',
  'BIconFonts',
  'BIconForward',
  'BIconForwardFill',
  'BIconFront',
  'BIconFuelPump',
  'BIconFuelPumpDiesel',
  'BIconFuelPumpDieselFill',
  'BIconFuelPumpFill',
  'BIconFullscreen',
  'BIconFullscreenExit',
  'BIconFunnel',
  'BIconFunnelFill',
  'BIconGear',
  'BIconGearFill',
  'BIconGearWide',
  'BIconGearWideConnected',
  'BIconGem',
  'BIconGenderAmbiguous',
  'BIconGenderFemale',
  'BIconGenderMale',
  'BIconGenderNeuter',
  'BIconGenderTrans',
  'BIconGeo',
  'BIconGeoAlt',
  'BIconGeoAltFill',
  'BIconGeoFill',
  'BIconGift',
  'BIconGiftFill',
  'BIconGit',
  'BIconGithub',
  'BIconGitlab',
  'BIconGlobe',
  'BIconGlobe2',
  'BIconGlobeAmericas',
  'BIconGlobeAsiaAustralia',
  'BIconGlobeCentralSouthAsia',
  'BIconGlobeEuropeAfrica',
  'BIconGoogle',
  'BIconGooglePlay',
  'BIconGpuCard',
  'BIconGraphDown',
  'BIconGraphDownArrow',
  'BIconGraphUp',
  'BIconGraphUpArrow',
  'BIconGrid',
  'BIconGrid1x2',
  'BIconGrid1x2Fill',
  'BIconGrid3x2',
  'BIconGrid3x2Gap',
  'BIconGrid3x2GapFill',
  'BIconGrid3x3',
  'BIconGrid3x3Gap',
  'BIconGrid3x3GapFill',
  'BIconGridFill',
  'BIconGripHorizontal',
  'BIconGripVertical',
  'BIconHCircle',
  'BIconHCircleFill',
  'BIconHSquare',
  'BIconHSquareFill',
  'BIconHammer',
  'BIconHandIndex',
  'BIconHandIndexFill',
  'BIconHandIndexThumb',
  'BIconHandIndexThumbFill',
  'BIconHandThumbsDown',
  'BIconHandThumbsDownFill',
  'BIconHandThumbsUp',
  'BIconHandThumbsUpFill',
  'BIconHandbag',
  'BIconHandbagFill',
  'BIconHash',
  'BIconHdd',
  'BIconHddFill',
  'BIconHddNetwork',
  'BIconHddNetworkFill',
  'BIconHddRack',
  'BIconHddRackFill',
  'BIconHddStack',
  'BIconHddStackFill',
  'BIconHdmi',
  'BIconHdmiFill',
  'BIconHeadphones',
  'BIconHeadset',
  'BIconHeadsetVr',
  'BIconHeart',
  'BIconHeartArrow',
  'BIconHeartFill',
  'BIconHeartHalf',
  'BIconHeartPulse',
  'BIconHeartPulseFill',
  'BIconHeartbreak',
  'BIconHeartbreakFill',
  'BIconHearts',
  'BIconHeptagon',
  'BIconHeptagonFill',
  'BIconHeptagonHalf',
  'BIconHexagon',
  'BIconHexagonFill',
  'BIconHexagonHalf',
  'BIconHighlighter',
  'BIconHighlights',
  'BIconHospital',
  'BIconHospitalFill',
  'BIconHourglass',
  'BIconHourglassBottom',
  'BIconHourglassSplit',
  'BIconHourglassTop',
  'BIconHouse',
  'BIconHouseAdd',
  'BIconHouseAddFill',
  'BIconHouseCheck',
  'BIconHouseCheckFill',
  'BIconHouseDash',
  'BIconHouseDashFill',
  'BIconHouseDoor',
  'BIconHouseDoorFill',
  'BIconHouseDown',
  'BIconHouseDownFill',
  'BIconHouseExclamation',
  'BIconHouseExclamationFill',
  'BIconHouseFill',
  'BIconHouseGear',
  'BIconHouseGearFill',
  'BIconHouseHeart',
  'BIconHouseHeartFill',
  'BIconHouseLock',
  'BIconHouseLockFill',
  'BIconHouseSlash',
  'BIconHouseSlashFill',
  'BIconHouseUp',
  'BIconHouseUpFill',
  'BIconHouseX',
  'BIconHouseXFill',
  'BIconHouses',
  'BIconHousesFill',
  'BIconHr',
  'BIconHurricane',
  'BIconHypnotize',
  'BIconImage',
  'BIconImageAlt',
  'BIconImageFill',
  'BIconImages',
  'BIconInbox',
  'BIconInboxFill',
  'BIconInboxes',
  'BIconInboxesFill',
  'BIconIncognito',
  'BIconIndent',
  'BIconInfinity',
  'BIconInfo',
  'BIconInfoCircle',
  'BIconInfoCircleFill',
  'BIconInfoLg',
  'BIconInfoSquare',
  'BIconInfoSquareFill',
  'BIconInputCursor',
  'BIconInputCursorText',
  'BIconInstagram',
  'BIconIntersect',
  'BIconJournal',
  'BIconJournalAlbum',
  'BIconJournalArrowDown',
  'BIconJournalArrowUp',
  'BIconJournalBookmark',
  'BIconJournalBookmarkFill',
  'BIconJournalCheck',
  'BIconJournalCode',
  'BIconJournalMedical',
  'BIconJournalMinus',
  'BIconJournalPlus',
  'BIconJournalRichtext',
  'BIconJournalText',
  'BIconJournalX',
  'BIconJournals',
  'BIconJoystick',
  'BIconJustify',
  'BIconJustifyLeft',
  'BIconJustifyRight',
  'BIconKanban',
  'BIconKanbanFill',
  'BIconKey',
  'BIconKeyFill',
  'BIconKeyboard',
  'BIconKeyboardFill',
  'BIconLadder',
  'BIconLamp',
  'BIconLampFill',
  'BIconLaptop',
  'BIconLaptopFill',
  'BIconLayerBackward',
  'BIconLayerForward',
  'BIconLayers',
  'BIconLayersFill',
  'BIconLayersHalf',
  'BIconLayoutSidebar',
  'BIconLayoutSidebarInset',
  'BIconLayoutSidebarInsetReverse',
  'BIconLayoutSidebarReverse',
  'BIconLayoutSplit',
  'BIconLayoutTextSidebar',
  'BIconLayoutTextSidebarReverse',
  'BIconLayoutTextWindow',
  'BIconLayoutTextWindowReverse',
  'BIconLayoutThreeColumns',
  'BIconLayoutWtf',
  'BIconLifePreserver',
  'BIconLightbulb',
  'BIconLightbulbFill',
  'BIconLightbulbOff',
  'BIconLightbulbOffFill',
  'BIconLightning',
  'BIconLightningCharge',
  'BIconLightningChargeFill',
  'BIconLightningFill',
  'BIconLine',
  'BIconLink',
  'BIconLink45deg',
  'BIconLinkedin',
  'BIconList',
  'BIconListCheck',
  'BIconListColumns',
  'BIconListColumnsReverse',
  'BIconListNested',
  'BIconListOl',
  'BIconListStars',
  'BIconListTask',
  'BIconListUl',
  'BIconLock',
  'BIconLockFill',
  'BIconLuggage',
  'BIconLuggageFill',
  'BIconLungs',
  'BIconLungsFill',
  'BIconMagic',
  'BIconMagnet',
  'BIconMagnetFill',
  'BIconMailbox',
  'BIconMailbox2',
  'BIconMailbox2Flag',
  'BIconMailboxFlag',
  'BIconMap',
  'BIconMapFill',
  'BIconMarkdown',
  'BIconMarkdownFill',
  'BIconMarkerTip',
  'BIconMask',
  'BIconMastodon',
  'BIconMedium',
  'BIconMegaphone',
  'BIconMegaphoneFill',
  'BIconMemory',
  'BIconMenuApp',
  'BIconMenuAppFill',
  'BIconMenuButton',
  'BIconMenuButtonFill',
  'BIconMenuButtonWide',
  'BIconMenuButtonWideFill',
  'BIconMenuDown',
  'BIconMenuUp',
  'BIconMessenger',
  'BIconMeta',
  'BIconMic',
  'BIconMicFill',
  'BIconMicMute',
  'BIconMicMuteFill',
  'BIconMicrosoft',
  'BIconMicrosoftTeams',
  'BIconMinecart',
  'BIconMinecartLoaded',
  'BIconModem',
  'BIconModemFill',
  'BIconMoisture',
  'BIconMoon',
  'BIconMoonFill',
  'BIconMoonStars',
  'BIconMoonStarsFill',
  'BIconMortarboard',
  'BIconMortarboardFill',
  'BIconMotherboard',
  'BIconMotherboardFill',
  'BIconMouse',
  'BIconMouse2',
  'BIconMouse2Fill',
  'BIconMouse3',
  'BIconMouse3Fill',
  'BIconMouseFill',
  'BIconMusicNote',
  'BIconMusicNoteBeamed',
  'BIconMusicNoteList',
  'BIconMusicPlayer',
  'BIconMusicPlayerFill',
  'BIconNewspaper',
  'BIconNintendoSwitch',
  'BIconNodeMinus',
  'BIconNodeMinusFill',
  'BIconNodePlus',
  'BIconNodePlusFill',
  'BIconNoiseReduction',
  'BIconNut',
  'BIconNutFill',
  'BIconNvidia',
  'BIconNvme',
  'BIconNvmeFill',
  'BIconOctagon',
  'BIconOctagonFill',
  'BIconOctagonHalf',
  'BIconOpencollective',
  'BIconOpticalAudio',
  'BIconOpticalAudioFill',
  'BIconOption',
  'BIconOutlet',
  'BIconPCircle',
  'BIconPCircleFill',
  'BIconPSquare',
  'BIconPSquareFill',
  'BIconPaintBucket',
  'BIconPalette',
  'BIconPalette2',
  'BIconPaletteFill',
  'BIconPaperclip',
  'BIconParagraph',
  'BIconPass',
  'BIconPassFill',
  'BIconPassport',
  'BIconPassportFill',
  'BIconPatchCheck',
  'BIconPatchCheckFill',
  'BIconPatchExclamation',
  'BIconPatchExclamationFill',
  'BIconPatchMinus',
  'BIconPatchMinusFill',
  'BIconPatchPlus',
  'BIconPatchPlusFill',
  'BIconPatchQuestion',
  'BIconPatchQuestionFill',
  'BIconPause',
  'BIconPauseBtn',
  'BIconPauseBtnFill',
  'BIconPauseCircle',
  'BIconPauseCircleFill',
  'BIconPauseFill',
  'BIconPaypal',
  'BIconPc',
  'BIconPcDisplay',
  'BIconPcDisplayHorizontal',
  'BIconPcHorizontal',
  'BIconPciCard',
  'BIconPciCardNetwork',
  'BIconPciCardSound',
  'BIconPeace',
  'BIconPeaceFill',
  'BIconPen',
  'BIconPenFill',
  'BIconPencil',
  'BIconPencilFill',
  'BIconPencilSquare',
  'BIconPentagon',
  'BIconPentagonFill',
  'BIconPentagonHalf',
  'BIconPeople',
  'BIconPeopleFill',
  'BIconPercent',
  'BIconPerson',
  'BIconPersonAdd',
  'BIconPersonArmsUp',
  'BIconPersonBadge',
  'BIconPersonBadgeFill',
  'BIconPersonBoundingBox',
  'BIconPersonCheck',
  'BIconPersonCheckFill',
  'BIconPersonCircle',
  'BIconPersonDash',
  'BIconPersonDashFill',
  'BIconPersonDown',
  'BIconPersonExclamation',
  'BIconPersonFill',
  'BIconPersonFillAdd',
  'BIconPersonFillCheck',
  'BIconPersonFillDash',
  'BIconPersonFillDown',
  'BIconPersonFillExclamation',
  'BIconPersonFillGear',
  'BIconPersonFillLock',
  'BIconPersonFillSlash',
  'BIconPersonFillUp',
  'BIconPersonFillX',
  'BIconPersonGear',
  'BIconPersonHeart',
  'BIconPersonHearts',
  'BIconPersonLinesFill',
  'BIconPersonLock',
  'BIconPersonPlus',
  'BIconPersonPlusFill',
  'BIconPersonRaisedHand',
  'BIconPersonRolodex',
  'BIconPersonSlash',
  'BIconPersonSquare',
  'BIconPersonStanding',
  'BIconPersonStandingDress',
  'BIconPersonUp',
  'BIconPersonVcard',
  'BIconPersonVcardFill',
  'BIconPersonVideo',
  'BIconPersonVideo2',
  'BIconPersonVideo3',
  'BIconPersonWalking',
  'BIconPersonWheelchair',
  'BIconPersonWorkspace',
  'BIconPersonX',
  'BIconPersonXFill',
  'BIconPhone',
  'BIconPhoneFill',
  'BIconPhoneFlip',
  'BIconPhoneLandscape',
  'BIconPhoneLandscapeFill',
  'BIconPhoneVibrate',
  'BIconPhoneVibrateFill',
  'BIconPieChart',
  'BIconPieChartFill',
  'BIconPiggyBank',
  'BIconPiggyBankFill',
  'BIconPin',
  'BIconPinAngle',
  'BIconPinAngleFill',
  'BIconPinFill',
  'BIconPinMap',
  'BIconPinMapFill',
  'BIconPinterest',
  'BIconPip',
  'BIconPipFill',
  'BIconPlay',
  'BIconPlayBtn',
  'BIconPlayBtnFill',
  'BIconPlayCircle',
  'BIconPlayCircleFill',
  'BIconPlayFill',
  'BIconPlaystation',
  'BIconPlug',
  'BIconPlugFill',
  'BIconPlugin',
  'BIconPlus',
  'BIconPlusCircle',
  'BIconPlusCircleDotted',
  'BIconPlusCircleFill',
  'BIconPlusLg',
  'BIconPlusSlashMinus',
  'BIconPlusSquare',
  'BIconPlusSquareDotted',
  'BIconPlusSquareFill',
  'BIconPostage',
  'BIconPostageFill',
  'BIconPostageHeart',
  'BIconPostageHeartFill',
  'BIconPostcard',
  'BIconPostcardFill',
  'BIconPostcardHeart',
  'BIconPostcardHeartFill',
  'BIconPower',
  'BIconPrescription',
  'BIconPrescription2',
  'BIconPrinter',
  'BIconPrinterFill',
  'BIconProjector',
  'BIconProjectorFill',
  'BIconPuzzle',
  'BIconPuzzleFill',
  'BIconQrCode',
  'BIconQrCodeScan',
  'BIconQuestion',
  'BIconQuestionCircle',
  'BIconQuestionCircleFill',
  'BIconQuestionDiamond',
  'BIconQuestionDiamondFill',
  'BIconQuestionLg',
  'BIconQuestionOctagon',
  'BIconQuestionOctagonFill',
  'BIconQuestionSquare',
  'BIconQuestionSquareFill',
  'BIconQuora',
  'BIconQuote',
  'BIconRCircle',
  'BIconRCircleFill',
  'BIconRSquare',
  'BIconRSquareFill',
  'BIconRadar',
  'BIconRadioactive',
  'BIconRainbow',
  'BIconReceipt',
  'BIconReceiptCutoff',
  'BIconReception0',
  'BIconReception1',
  'BIconReception2',
  'BIconReception3',
  'BIconReception4',
  'BIconRecord',
  'BIconRecord2',
  'BIconRecord2Fill',
  'BIconRecordBtn',
  'BIconRecordBtnFill',
  'BIconRecordCircle',
  'BIconRecordCircleFill',
  'BIconRecordFill',
  'BIconRecycle',
  'BIconReddit',
  'BIconRegex',
  'BIconRepeat',
  'BIconRepeat1',
  'BIconReply',
  'BIconReplyAll',
  'BIconReplyAllFill',
  'BIconReplyFill',
  'BIconRewind',
  'BIconRewindBtn',
  'BIconRewindBtnFill',
  'BIconRewindCircle',
  'BIconRewindCircleFill',
  'BIconRewindFill',
  'BIconRobot',
  'BIconRocket',
  'BIconRocketFill',
  'BIconRocketTakeoff',
  'BIconRocketTakeoffFill',
  'BIconRouter',
  'BIconRouterFill',
  'BIconRss',
  'BIconRssFill',
  'BIconRulers',
  'BIconSafe',
  'BIconSafe2',
  'BIconSafe2Fill',
  'BIconSafeFill',
  'BIconSave',
  'BIconSave2',
  'BIconSave2Fill',
  'BIconSaveFill',
  'BIconScissors',
  'BIconScooter',
  'BIconScrewdriver',
  'BIconSdCard',
  'BIconSdCardFill',
  'BIconSearch',
  'BIconSearchHeart',
  'BIconSearchHeartFill',
  'BIconSegmentedNav',
  'BIconSend',
  'BIconSendArrowDown',
  'BIconSendArrowDownFill',
  'BIconSendArrowUp',
  'BIconSendArrowUpFill',
  'BIconSendCheck',
  'BIconSendCheckFill',
  'BIconSendDash',
  'BIconSendDashFill',
  'BIconSendExclamation',
  'BIconSendExclamationFill',
  'BIconSendFill',
  'BIconSendPlus',
  'BIconSendPlusFill',
  'BIconSendSlash',
  'BIconSendSlashFill',
  'BIconSendX',
  'BIconSendXFill',
  'BIconServer',
  'BIconShadows',
  'BIconShare',
  'BIconShareFill',
  'BIconShield',
  'BIconShieldCheck',
  'BIconShieldExclamation',
  'BIconShieldFill',
  'BIconShieldFillCheck',
  'BIconShieldFillExclamation',
  'BIconShieldFillMinus',
  'BIconShieldFillPlus',
  'BIconShieldFillX',
  'BIconShieldLock',
  'BIconShieldLockFill',
  'BIconShieldMinus',
  'BIconShieldPlus',
  'BIconShieldShaded',
  'BIconShieldSlash',
  'BIconShieldSlashFill',
  'BIconShieldX',
  'BIconShift',
  'BIconShiftFill',
  'BIconShop',
  'BIconShopWindow',
  'BIconShuffle',
  'BIconSignDeadEnd',
  'BIconSignDeadEndFill',
  'BIconSignDoNotEnter',
  'BIconSignDoNotEnterFill',
  'BIconSignIntersection',
  'BIconSignIntersectionFill',
  'BIconSignIntersectionSide',
  'BIconSignIntersectionSideFill',
  'BIconSignIntersectionT',
  'BIconSignIntersectionTFill',
  'BIconSignIntersectionY',
  'BIconSignIntersectionYFill',
  'BIconSignMergeLeft',
  'BIconSignMergeLeftFill',
  'BIconSignMergeRight',
  'BIconSignMergeRightFill',
  'BIconSignNoLeftTurn',
  'BIconSignNoLeftTurnFill',
  'BIconSignNoParking',
  'BIconSignNoParkingFill',
  'BIconSignNoRightTurn',
  'BIconSignNoRightTurnFill',
  'BIconSignRailroad',
  'BIconSignRailroadFill',
  'BIconSignStop',
  'BIconSignStopFill',
  'BIconSignStopLights',
  'BIconSignStopLightsFill',
  'BIconSignTurnLeft',
  'BIconSignTurnLeftFill',
  'BIconSignTurnRight',
  'BIconSignTurnRightFill',
  'BIconSignTurnSlightLeft',
  'BIconSignTurnSlightLeftFill',
  'BIconSignTurnSlightRight',
  'BIconSignTurnSlightRightFill',
  'BIconSignYield',
  'BIconSignYieldFill',
  'BIconSignal',
  'BIconSignpost',
  'BIconSignpost2',
  'BIconSignpost2Fill',
  'BIconSignpostFill',
  'BIconSignpostSplit',
  'BIconSignpostSplitFill',
  'BIconSim',
  'BIconSimFill',
  'BIconSimSlash',
  'BIconSimSlashFill',
  'BIconSinaWeibo',
  'BIconSkipBackward',
  'BIconSkipBackwardBtn',
  'BIconSkipBackwardBtnFill',
  'BIconSkipBackwardCircle',
  'BIconSkipBackwardCircleFill',
  'BIconSkipBackwardFill',
  'BIconSkipEnd',
  'BIconSkipEndBtn',
  'BIconSkipEndBtnFill',
  'BIconSkipEndCircle',
  'BIconSkipEndCircleFill',
  'BIconSkipEndFill',
  'BIconSkipForward',
  'BIconSkipForwardBtn',
  'BIconSkipForwardBtnFill',
  'BIconSkipForwardCircle',
  'BIconSkipForwardCircleFill',
  'BIconSkipForwardFill',
  'BIconSkipStart',
  'BIconSkipStartBtn',
  'BIconSkipStartBtnFill',
  'BIconSkipStartCircle',
  'BIconSkipStartCircleFill',
  'BIconSkipStartFill',
  'BIconSkype',
  'BIconSlack',
  'BIconSlash',
  'BIconSlashCircle',
  'BIconSlashCircleFill',
  'BIconSlashLg',
  'BIconSlashSquare',
  'BIconSlashSquareFill',
  'BIconSliders',
  'BIconSliders2',
  'BIconSliders2Vertical',
  'BIconSmartwatch',
  'BIconSnapchat',
  'BIconSnow',
  'BIconSnow2',
  'BIconSnow3',
  'BIconSortAlphaDown',
  'BIconSortAlphaDownAlt',
  'BIconSortAlphaUp',
  'BIconSortAlphaUpAlt',
  'BIconSortDown',
  'BIconSortDownAlt',
  'BIconSortNumericDown',
  'BIconSortNumericDownAlt',
  'BIconSortNumericUp',
  'BIconSortNumericUpAlt',
  'BIconSortUp',
  'BIconSortUpAlt',
  'BIconSoundwave',
  'BIconSourceforge',
  'BIconSpeaker',
  'BIconSpeakerFill',
  'BIconSpeedometer',
  'BIconSpeedometer2',
  'BIconSpellcheck',
  'BIconSpotify',
  'BIconSquare',
  'BIconSquareFill',
  'BIconSquareHalf',
  'BIconStack',
  'BIconStackOverflow',
  'BIconStar',
  'BIconStarFill',
  'BIconStarHalf',
  'BIconStars',
  'BIconSteam',
  'BIconStickies',
  'BIconStickiesFill',
  'BIconSticky',
  'BIconStickyFill',
  'BIconStop',
  'BIconStopBtn',
  'BIconStopBtnFill',
  'BIconStopCircle',
  'BIconStopCircleFill',
  'BIconStopFill',
  'BIconStoplights',
  'BIconStoplightsFill',
  'BIconStopwatch',
  'BIconStopwatchFill',
  'BIconStrava',
  'BIconStripe',
  'BIconSubscript',
  'BIconSubstack',
  'BIconSubtract',
  'BIconSuitClub',
  'BIconSuitClubFill',
  'BIconSuitDiamond',
  'BIconSuitDiamondFill',
  'BIconSuitHeart',
  'BIconSuitHeartFill',
  'BIconSuitSpade',
  'BIconSuitSpadeFill',
  'BIconSuitcase',
  'BIconSuitcase2',
  'BIconSuitcase2Fill',
  'BIconSuitcaseFill',
  'BIconSuitcaseLg',
  'BIconSuitcaseLgFill',
  'BIconSun',
  'BIconSunFill',
  'BIconSunglasses',
  'BIconSunrise',
  'BIconSunriseFill',
  'BIconSunset',
  'BIconSunsetFill',
  'BIconSuperscript',
  'BIconSymmetryHorizontal',
  'BIconSymmetryVertical',
  'BIconTable',
  'BIconTablet',
  'BIconTabletFill',
  'BIconTabletLandscape',
  'BIconTabletLandscapeFill',
  'BIconTag',
  'BIconTagFill',
  'BIconTags',
  'BIconTagsFill',
  'BIconTaxiFront',
  'BIconTaxiFrontFill',
  'BIconTelegram',
  'BIconTelephone',
  'BIconTelephoneFill',
  'BIconTelephoneForward',
  'BIconTelephoneForwardFill',
  'BIconTelephoneInbound',
  'BIconTelephoneInboundFill',
  'BIconTelephoneMinus',
  'BIconTelephoneMinusFill',
  'BIconTelephoneOutbound',
  'BIconTelephoneOutboundFill',
  'BIconTelephonePlus',
  'BIconTelephonePlusFill',
  'BIconTelephoneX',
  'BIconTelephoneXFill',
  'BIconTencentQq',
  'BIconTerminal',
  'BIconTerminalDash',
  'BIconTerminalFill',
  'BIconTerminalPlus',
  'BIconTerminalSplit',
  'BIconTerminalX',
  'BIconTextCenter',
  'BIconTextIndentLeft',
  'BIconTextIndentRight',
  'BIconTextLeft',
  'BIconTextParagraph',
  'BIconTextRight',
  'BIconTextWrap',
  'BIconTextarea',
  'BIconTextareaResize',
  'BIconTextareaT',
  'BIconThermometer',
  'BIconThermometerHalf',
  'BIconThermometerHigh',
  'BIconThermometerLow',
  'BIconThermometerSnow',
  'BIconThermometerSun',
  'BIconThreads',
  'BIconThreadsFill',
  'BIconThreeDots',
  'BIconThreeDotsVertical',
  'BIconThunderbolt',
  'BIconThunderboltFill',
  'BIconTicket',
  'BIconTicketDetailed',
  'BIconTicketDetailedFill',
  'BIconTicketFill',
  'BIconTicketPerforated',
  'BIconTicketPerforatedFill',
  'BIconTiktok',
  'BIconToggle2Off',
  'BIconToggle2On',
  'BIconToggleOff',
  'BIconToggleOn',
  'BIconToggles',
  'BIconToggles2',
  'BIconTools',
  'BIconTornado',
  'BIconTrainFreightFront',
  'BIconTrainFreightFrontFill',
  'BIconTrainFront',
  'BIconTrainFrontFill',
  'BIconTrainLightrailFront',
  'BIconTrainLightrailFrontFill',
  'BIconTranslate',
  'BIconTransparency',
  'BIconTrash',
  'BIconTrash2',
  'BIconTrash2Fill',
  'BIconTrash3',
  'BIconTrash3Fill',
  'BIconTrashFill',
  'BIconTree',
  'BIconTreeFill',
  'BIconTrello',
  'BIconTriangle',
  'BIconTriangleFill',
  'BIconTriangleHalf',
  'BIconTrophy',
  'BIconTrophyFill',
  'BIconTropicalStorm',
  'BIconTruck',
  'BIconTruckFlatbed',
  'BIconTruckFront',
  'BIconTruckFrontFill',
  'BIconTsunami',
  'BIconTv',
  'BIconTvFill',
  'BIconTwitch',
  'BIconTwitter',
  'BIconTwitterX',
  'BIconType',
  'BIconTypeBold',
  'BIconTypeH1',
  'BIconTypeH2',
  'BIconTypeH3',
  'BIconTypeH4',
  'BIconTypeH5',
  'BIconTypeH6',
  'BIconTypeItalic',
  'BIconTypeStrikethrough',
  'BIconTypeUnderline',
  'BIconUbuntu',
  'BIconUiChecks',
  'BIconUiChecksGrid',
  'BIconUiRadios',
  'BIconUiRadiosGrid',
  'BIconUmbrella',
  'BIconUmbrellaFill',
  'BIconUnindent',
  'BIconUnion',
  'BIconUnity',
  'BIconUniversalAccess',
  'BIconUniversalAccessCircle',
  'BIconUnlock',
  'BIconUnlockFill',
  'BIconUpc',
  'BIconUpcScan',
  'BIconUpload',
  'BIconUsb',
  'BIconUsbC',
  'BIconUsbCFill',
  'BIconUsbDrive',
  'BIconUsbDriveFill',
  'BIconUsbFill',
  'BIconUsbMicro',
  'BIconUsbMicroFill',
  'BIconUsbMini',
  'BIconUsbMiniFill',
  'BIconUsbPlug',
  'BIconUsbPlugFill',
  'BIconUsbSymbol',
  'BIconValentine',
  'BIconValentine2',
  'BIconVectorPen',
  'BIconViewList',
  'BIconViewStacked',
  'BIconVignette',
  'BIconVimeo',
  'BIconVinyl',
  'BIconVinylFill',
  'BIconVirus',
  'BIconVirus2',
  'BIconVoicemail',
  'BIconVolumeDown',
  'BIconVolumeDownFill',
  'BIconVolumeMute',
  'BIconVolumeMuteFill',
  'BIconVolumeOff',
  'BIconVolumeOffFill',
  'BIconVolumeUp',
  'BIconVolumeUpFill',
  'BIconVr',
  'BIconWallet',
  'BIconWallet2',
  'BIconWalletFill',
  'BIconWatch',
  'BIconWater',
  'BIconWebcam',
  'BIconWebcamFill',
  'BIconWechat',
  'BIconWhatsapp',
  'BIconWifi',
  'BIconWifi1',
  'BIconWifi2',
  'BIconWifiOff',
  'BIconWikipedia',
  'BIconWind',
  'BIconWindow',
  'BIconWindowDash',
  'BIconWindowDesktop',
  'BIconWindowDock',
  'BIconWindowFullscreen',
  'BIconWindowPlus',
  'BIconWindowSidebar',
  'BIconWindowSplit',
  'BIconWindowStack',
  'BIconWindowX',
  'BIconWindows',
  'BIconWordpress',
  'BIconWrench',
  'BIconWrenchAdjustable',
  'BIconWrenchAdjustableCircle',
  'BIconWrenchAdjustableCircleFill',
  'BIconX',
  'BIconXCircle',
  'BIconXCircleFill',
  'BIconXDiamond',
  'BIconXDiamondFill',
  'BIconXLg',
  'BIconXOctagon',
  'BIconXOctagonFill',
  'BIconXSquare',
  'BIconXSquareFill',
  'BIconXbox',
  'BIconYelp',
  'BIconYinYang',
  'BIconYoutube',
  'BIconZoomIn',
  'BIconZoomOut'
]

// Export the icons plugin
export const IconsPlugin = /*#__PURE__*/ pluginFactoryNoConfig({
  components: {
    // Icon helper component
    BIcon,
    // Icon stacking component
    BIconstack,
    // BootstrapVue custom icon components
    BIconBlank,
    // Bootstrap icon components
    BIcon0Circle,
    BIcon0CircleFill,
    BIcon0Square,
    BIcon0SquareFill,
    BIcon123,
    BIcon1Circle,
    BIcon1CircleFill,
    BIcon1Square,
    BIcon1SquareFill,
    BIcon2Circle,
    BIcon2CircleFill,
    BIcon2Square,
    BIcon2SquareFill,
    BIcon3Circle,
    BIcon3CircleFill,
    BIcon3Square,
    BIcon3SquareFill,
    BIcon4Circle,
    BIcon4CircleFill,
    BIcon4Square,
    BIcon4SquareFill,
    BIcon5Circle,
    BIcon5CircleFill,
    BIcon5Square,
    BIcon5SquareFill,
    BIcon6Circle,
    BIcon6CircleFill,
    BIcon6Square,
    BIcon6SquareFill,
    BIcon7Circle,
    BIcon7CircleFill,
    BIcon7Square,
    BIcon7SquareFill,
    BIcon8Circle,
    BIcon8CircleFill,
    BIcon8Square,
    BIcon8SquareFill,
    BIcon9Circle,
    BIcon9CircleFill,
    BIcon9Square,
    BIcon9SquareFill,
    BIconActivity,
    BIconAirplane,
    BIconAirplaneEngines,
    BIconAirplaneEnginesFill,
    BIconAirplaneFill,
    BIconAlarm,
    BIconAlarmFill,
    BIconAlexa,
    BIconAlignBottom,
    BIconAlignCenter,
    BIconAlignEnd,
    BIconAlignMiddle,
    BIconAlignStart,
    BIconAlignTop,
    BIconAlipay,
    BIconAlphabet,
    BIconAlphabetUppercase,
    BIconAlt,
    BIconAmazon,
    BIconAmd,
    BIconAndroid,
    BIconAndroid2,
    BIconApp,
    BIconAppIndicator,
    BIconApple,
    BIconArchive,
    BIconArchiveFill,
    BIconArrow90degDown,
    BIconArrow90degLeft,
    BIconArrow90degRight,
    BIconArrow90degUp,
    BIconArrowBarDown,
    BIconArrowBarLeft,
    BIconArrowBarRight,
    BIconArrowBarUp,
    BIconArrowClockwise,
    BIconArrowCounterclockwise,
    BIconArrowDown,
    BIconArrowDownCircle,
    BIconArrowDownCircleFill,
    BIconArrowDownLeft,
    BIconArrowDownLeftCircle,
    BIconArrowDownLeftCircleFill,
    BIconArrowDownLeftSquare,
    BIconArrowDownLeftSquareFill,
    BIconArrowDownRight,
    BIconArrowDownRightCircle,
    BIconArrowDownRightCircleFill,
    BIconArrowDownRightSquare,
    BIconArrowDownRightSquareFill,
    BIconArrowDownShort,
    BIconArrowDownSquare,
    BIconArrowDownSquareFill,
    BIconArrowDownUp,
    BIconArrowLeft,
    BIconArrowLeftCircle,
    BIconArrowLeftCircleFill,
    BIconArrowLeftRight,
    BIconArrowLeftShort,
    BIconArrowLeftSquare,
    BIconArrowLeftSquareFill,
    BIconArrowRepeat,
    BIconArrowReturnLeft,
    BIconArrowReturnRight,
    BIconArrowRight,
    BIconArrowRightCircle,
    BIconArrowRightCircleFill,
    BIconArrowRightShort,
    BIconArrowRightSquare,
    BIconArrowRightSquareFill,
    BIconArrowThroughHeart,
    BIconArrowThroughHeartFill,
    BIconArrowUp,
    BIconArrowUpCircle,
    BIconArrowUpCircleFill,
    BIconArrowUpLeft,
    BIconArrowUpLeftCircle,
    BIconArrowUpLeftCircleFill,
    BIconArrowUpLeftSquare,
    BIconArrowUpLeftSquareFill,
    BIconArrowUpRight,
    BIconArrowUpRightCircle,
    BIconArrowUpRightCircleFill,
    BIconArrowUpRightSquare,
    BIconArrowUpRightSquareFill,
    BIconArrowUpShort,
    BIconArrowUpSquare,
    BIconArrowUpSquareFill,
    BIconArrows,
    BIconArrowsAngleContract,
    BIconArrowsAngleExpand,
    BIconArrowsCollapse,
    BIconArrowsCollapseVertical,
    BIconArrowsExpand,
    BIconArrowsExpandVertical,
    BIconArrowsFullscreen,
    BIconArrowsMove,
    BIconArrowsVertical,
    BIconAspectRatio,
    BIconAspectRatioFill,
    BIconAsterisk,
    BIconAt,
    BIconAward,
    BIconAwardFill,
    BIconBack,
    BIconBackpack,
    BIconBackpack2,
    BIconBackpack2Fill,
    BIconBackpack3,
    BIconBackpack3Fill,
    BIconBackpack4,
    BIconBackpack4Fill,
    BIconBackpackFill,
    BIconBackspace,
    BIconBackspaceFill,
    BIconBackspaceReverse,
    BIconBackspaceReverseFill,
    BIconBadge3d,
    BIconBadge3dFill,
    BIconBadge4k,
    BIconBadge4kFill,
    BIconBadge8k,
    BIconBadge8kFill,
    BIconBadgeAd,
    BIconBadgeAdFill,
    BIconBadgeAr,
    BIconBadgeArFill,
    BIconBadgeCc,
    BIconBadgeCcFill,
    BIconBadgeHd,
    BIconBadgeHdFill,
    BIconBadgeSd,
    BIconBadgeSdFill,
    BIconBadgeTm,
    BIconBadgeTmFill,
    BIconBadgeVo,
    BIconBadgeVoFill,
    BIconBadgeVr,
    BIconBadgeVrFill,
    BIconBadgeWc,
    BIconBadgeWcFill,
    BIconBag,
    BIconBagCheck,
    BIconBagCheckFill,
    BIconBagDash,
    BIconBagDashFill,
    BIconBagFill,
    BIconBagHeart,
    BIconBagHeartFill,
    BIconBagPlus,
    BIconBagPlusFill,
    BIconBagX,
    BIconBagXFill,
    BIconBalloon,
    BIconBalloonFill,
    BIconBalloonHeart,
    BIconBalloonHeartFill,
    BIconBan,
    BIconBanFill,
    BIconBandaid,
    BIconBandaidFill,
    BIconBank,
    BIconBank2,
    BIconBarChart,
    BIconBarChartFill,
    BIconBarChartLine,
    BIconBarChartLineFill,
    BIconBarChartSteps,
    BIconBasket,
    BIconBasket2,
    BIconBasket2Fill,
    BIconBasket3,
    BIconBasket3Fill,
    BIconBasketFill,
    BIconBattery,
    BIconBatteryCharging,
    BIconBatteryFull,
    BIconBatteryHalf,
    BIconBehance,
    BIconBell,
    BIconBellFill,
    BIconBellSlash,
    BIconBellSlashFill,
    BIconBezier,
    BIconBezier2,
    BIconBicycle,
    BIconBing,
    BIconBinoculars,
    BIconBinocularsFill,
    BIconBlockquoteLeft,
    BIconBlockquoteRight,
    BIconBluetooth,
    BIconBodyText,
    BIconBook,
    BIconBookFill,
    BIconBookHalf,
    BIconBookmark,
    BIconBookmarkCheck,
    BIconBookmarkCheckFill,
    BIconBookmarkDash,
    BIconBookmarkDashFill,
    BIconBookmarkFill,
    BIconBookmarkHeart,
    BIconBookmarkHeartFill,
    BIconBookmarkPlus,
    BIconBookmarkPlusFill,
    BIconBookmarkStar,
    BIconBookmarkStarFill,
    BIconBookmarkX,
    BIconBookmarkXFill,
    BIconBookmarks,
    BIconBookmarksFill,
    BIconBookshelf,
    BIconBoombox,
    BIconBoomboxFill,
    BIconBootstrap,
    BIconBootstrapFill,
    BIconBootstrapReboot,
    BIconBorder,
    BIconBorderAll,
    BIconBorderBottom,
    BIconBorderCenter,
    BIconBorderInner,
    BIconBorderLeft,
    BIconBorderMiddle,
    BIconBorderOuter,
    BIconBorderRight,
    BIconBorderStyle,
    BIconBorderTop,
    BIconBorderWidth,
    BIconBoundingBox,
    BIconBoundingBoxCircles,
    BIconBox,
    BIconBox2,
    BIconBox2Fill,
    BIconBox2Heart,
    BIconBox2HeartFill,
    BIconBoxArrowDown,
    BIconBoxArrowDownLeft,
    BIconBoxArrowDownRight,
    BIconBoxArrowInDown,
    BIconBoxArrowInDownLeft,
    BIconBoxArrowInDownRight,
    BIconBoxArrowInLeft,
    BIconBoxArrowInRight,
    BIconBoxArrowInUp,
    BIconBoxArrowInUpLeft,
    BIconBoxArrowInUpRight,
    BIconBoxArrowLeft,
    BIconBoxArrowRight,
    BIconBoxArrowUp,
    BIconBoxArrowUpLeft,
    BIconBoxArrowUpRight,
    BIconBoxFill,
    BIconBoxSeam,
    BIconBoxSeamFill,
    BIconBoxes,
    BIconBraces,
    BIconBracesAsterisk,
    BIconBricks,
    BIconBriefcase,
    BIconBriefcaseFill,
    BIconBrightnessAltHigh,
    BIconBrightnessAltHighFill,
    BIconBrightnessAltLow,
    BIconBrightnessAltLowFill,
    BIconBrightnessHigh,
    BIconBrightnessHighFill,
    BIconBrightnessLow,
    BIconBrightnessLowFill,
    BIconBrilliance,
    BIconBroadcast,
    BIconBroadcastPin,
    BIconBrowserChrome,
    BIconBrowserEdge,
    BIconBrowserFirefox,
    BIconBrowserSafari,
    BIconBrush,
    BIconBrushFill,
    BIconBucket,
    BIconBucketFill,
    BIconBug,
    BIconBugFill,
    BIconBuilding,
    BIconBuildingAdd,
    BIconBuildingCheck,
    BIconBuildingDash,
    BIconBuildingDown,
    BIconBuildingExclamation,
    BIconBuildingFill,
    BIconBuildingFillAdd,
    BIconBuildingFillCheck,
    BIconBuildingFillDash,
    BIconBuildingFillDown,
    BIconBuildingFillExclamation,
    BIconBuildingFillGear,
    BIconBuildingFillLock,
    BIconBuildingFillSlash,
    BIconBuildingFillUp,
    BIconBuildingFillX,
    BIconBuildingGear,
    BIconBuildingLock,
    BIconBuildingSlash,
    BIconBuildingUp,
    BIconBuildingX,
    BIconBuildings,
    BIconBuildingsFill,
    BIconBullseye,
    BIconBusFront,
    BIconBusFrontFill,
    BIconCCircle,
    BIconCCircleFill,
    BIconCSquare,
    BIconCSquareFill,
    BIconCake,
    BIconCake2,
    BIconCake2Fill,
    BIconCakeFill,
    BIconCalculator,
    BIconCalculatorFill,
    BIconCalendar,
    BIconCalendar2,
    BIconCalendar2Check,
    BIconCalendar2CheckFill,
    BIconCalendar2Date,
    BIconCalendar2DateFill,
    BIconCalendar2Day,
    BIconCalendar2DayFill,
    BIconCalendar2Event,
    BIconCalendar2EventFill,
    BIconCalendar2Fill,
    BIconCalendar2Heart,
    BIconCalendar2HeartFill,
    BIconCalendar2Minus,
    BIconCalendar2MinusFill,
    BIconCalendar2Month,
    BIconCalendar2MonthFill,
    BIconCalendar2Plus,
    BIconCalendar2PlusFill,
    BIconCalendar2Range,
    BIconCalendar2RangeFill,
    BIconCalendar2Week,
    BIconCalendar2WeekFill,
    BIconCalendar2X,
    BIconCalendar2XFill,
    BIconCalendar3,
    BIconCalendar3Event,
    BIconCalendar3EventFill,
    BIconCalendar3Fill,
    BIconCalendar3Range,
    BIconCalendar3RangeFill,
    BIconCalendar3Week,
    BIconCalendar3WeekFill,
    BIconCalendar4,
    BIconCalendar4Event,
    BIconCalendar4Range,
    BIconCalendar4Week,
    BIconCalendarCheck,
    BIconCalendarCheckFill,
    BIconCalendarDate,
    BIconCalendarDateFill,
    BIconCalendarDay,
    BIconCalendarDayFill,
    BIconCalendarEvent,
    BIconCalendarEventFill,
    BIconCalendarFill,
    BIconCalendarHeart,
    BIconCalendarHeartFill,
    BIconCalendarMinus,
    BIconCalendarMinusFill,
    BIconCalendarMonth,
    BIconCalendarMonthFill,
    BIconCalendarPlus,
    BIconCalendarPlusFill,
    BIconCalendarRange,
    BIconCalendarRangeFill,
    BIconCalendarWeek,
    BIconCalendarWeekFill,
    BIconCalendarX,
    BIconCalendarXFill,
    BIconCamera,
    BIconCamera2,
    BIconCameraFill,
    BIconCameraReels,
    BIconCameraReelsFill,
    BIconCameraVideo,
    BIconCameraVideoFill,
    BIconCameraVideoOff,
    BIconCameraVideoOffFill,
    BIconCapslock,
    BIconCapslockFill,
    BIconCapsule,
    BIconCapsulePill,
    BIconCarFront,
    BIconCarFrontFill,
    BIconCardChecklist,
    BIconCardHeading,
    BIconCardImage,
    BIconCardList,
    BIconCardText,
    BIconCaretDown,
    BIconCaretDownFill,
    BIconCaretDownSquare,
    BIconCaretDownSquareFill,
    BIconCaretLeft,
    BIconCaretLeftFill,
    BIconCaretLeftSquare,
    BIconCaretLeftSquareFill,
    BIconCaretRight,
    BIconCaretRightFill,
    BIconCaretRightSquare,
    BIconCaretRightSquareFill,
    BIconCaretUp,
    BIconCaretUpFill,
    BIconCaretUpSquare,
    BIconCaretUpSquareFill,
    BIconCart,
    BIconCart2,
    BIconCart3,
    BIconCart4,
    BIconCartCheck,
    BIconCartCheckFill,
    BIconCartDash,
    BIconCartDashFill,
    BIconCartFill,
    BIconCartPlus,
    BIconCartPlusFill,
    BIconCartX,
    BIconCartXFill,
    BIconCash,
    BIconCashCoin,
    BIconCashStack,
    BIconCassette,
    BIconCassetteFill,
    BIconCast,
    BIconCcCircle,
    BIconCcCircleFill,
    BIconCcSquare,
    BIconCcSquareFill,
    BIconChat,
    BIconChatDots,
    BIconChatDotsFill,
    BIconChatFill,
    BIconChatHeart,
    BIconChatHeartFill,
    BIconChatLeft,
    BIconChatLeftDots,
    BIconChatLeftDotsFill,
    BIconChatLeftFill,
    BIconChatLeftHeart,
    BIconChatLeftHeartFill,
    BIconChatLeftQuote,
    BIconChatLeftQuoteFill,
    BIconChatLeftText,
    BIconChatLeftTextFill,
    BIconChatQuote,
    BIconChatQuoteFill,
    BIconChatRight,
    BIconChatRightDots,
    BIconChatRightDotsFill,
    BIconChatRightFill,
    BIconChatRightHeart,
    BIconChatRightHeartFill,
    BIconChatRightQuote,
    BIconChatRightQuoteFill,
    BIconChatRightText,
    BIconChatRightTextFill,
    BIconChatSquare,
    BIconChatSquareDots,
    BIconChatSquareDotsFill,
    BIconChatSquareFill,
    BIconChatSquareHeart,
    BIconChatSquareHeartFill,
    BIconChatSquareQuote,
    BIconChatSquareQuoteFill,
    BIconChatSquareText,
    BIconChatSquareTextFill,
    BIconChatText,
    BIconChatTextFill,
    BIconCheck,
    BIconCheck2,
    BIconCheck2All,
    BIconCheck2Circle,
    BIconCheck2Square,
    BIconCheckAll,
    BIconCheckCircle,
    BIconCheckCircleFill,
    BIconCheckLg,
    BIconCheckSquare,
    BIconCheckSquareFill,
    BIconChevronBarContract,
    BIconChevronBarDown,
    BIconChevronBarExpand,
    BIconChevronBarLeft,
    BIconChevronBarRight,
    BIconChevronBarUp,
    BIconChevronCompactDown,
    BIconChevronCompactLeft,
    BIconChevronCompactRight,
    BIconChevronCompactUp,
    BIconChevronContract,
    BIconChevronDoubleDown,
    BIconChevronDoubleLeft,
    BIconChevronDoubleRight,
    BIconChevronDoubleUp,
    BIconChevronDown,
    BIconChevronExpand,
    BIconChevronLeft,
    BIconChevronRight,
    BIconChevronUp,
    BIconCircle,
    BIconCircleFill,
    BIconCircleHalf,
    BIconCircleSquare,
    BIconClipboard,
    BIconClipboard2,
    BIconClipboard2Check,
    BIconClipboard2CheckFill,
    BIconClipboard2Data,
    BIconClipboard2DataFill,
    BIconClipboard2Fill,
    BIconClipboard2Heart,
    BIconClipboard2HeartFill,
    BIconClipboard2Minus,
    BIconClipboard2MinusFill,
    BIconClipboard2Plus,
    BIconClipboard2PlusFill,
    BIconClipboard2Pulse,
    BIconClipboard2PulseFill,
    BIconClipboard2X,
    BIconClipboard2XFill,
    BIconClipboardCheck,
    BIconClipboardCheckFill,
    BIconClipboardData,
    BIconClipboardDataFill,
    BIconClipboardFill,
    BIconClipboardHeart,
    BIconClipboardHeartFill,
    BIconClipboardMinus,
    BIconClipboardMinusFill,
    BIconClipboardPlus,
    BIconClipboardPlusFill,
    BIconClipboardPulse,
    BIconClipboardX,
    BIconClipboardXFill,
    BIconClock,
    BIconClockFill,
    BIconClockHistory,
    BIconCloud,
    BIconCloudArrowDown,
    BIconCloudArrowDownFill,
    BIconCloudArrowUp,
    BIconCloudArrowUpFill,
    BIconCloudCheck,
    BIconCloudCheckFill,
    BIconCloudDownload,
    BIconCloudDownloadFill,
    BIconCloudDrizzle,
    BIconCloudDrizzleFill,
    BIconCloudFill,
    BIconCloudFog,
    BIconCloudFog2,
    BIconCloudFog2Fill,
    BIconCloudFogFill,
    BIconCloudHail,
    BIconCloudHailFill,
    BIconCloudHaze,
    BIconCloudHaze2,
    BIconCloudHaze2Fill,
    BIconCloudHazeFill,
    BIconCloudLightning,
    BIconCloudLightningFill,
    BIconCloudLightningRain,
    BIconCloudLightningRainFill,
    BIconCloudMinus,
    BIconCloudMinusFill,
    BIconCloudMoon,
    BIconCloudMoonFill,
    BIconCloudPlus,
    BIconCloudPlusFill,
    BIconCloudRain,
    BIconCloudRainFill,
    BIconCloudRainHeavy,
    BIconCloudRainHeavyFill,
    BIconCloudSlash,
    BIconCloudSlashFill,
    BIconCloudSleet,
    BIconCloudSleetFill,
    BIconCloudSnow,
    BIconCloudSnowFill,
    BIconCloudSun,
    BIconCloudSunFill,
    BIconCloudUpload,
    BIconCloudUploadFill,
    BIconClouds,
    BIconCloudsFill,
    BIconCloudy,
    BIconCloudyFill,
    BIconCode,
    BIconCodeSlash,
    BIconCodeSquare,
    BIconCoin,
    BIconCollection,
    BIconCollectionFill,
    BIconCollectionPlay,
    BIconCollectionPlayFill,
    BIconColumns,
    BIconColumnsGap,
    BIconCommand,
    BIconCompass,
    BIconCompassFill,
    BIconCone,
    BIconConeStriped,
    BIconController,
    BIconCookie,
    BIconCopy,
    BIconCpu,
    BIconCpuFill,
    BIconCreditCard,
    BIconCreditCard2Back,
    BIconCreditCard2BackFill,
    BIconCreditCard2Front,
    BIconCreditCard2FrontFill,
    BIconCreditCardFill,
    BIconCrop,
    BIconCrosshair,
    BIconCrosshair2,
    BIconCup,
    BIconCupFill,
    BIconCupHot,
    BIconCupHotFill,
    BIconCupStraw,
    BIconCurrencyBitcoin,
    BIconCurrencyDollar,
    BIconCurrencyEuro,
    BIconCurrencyExchange,
    BIconCurrencyPound,
    BIconCurrencyRupee,
    BIconCurrencyYen,
    BIconCursor,
    BIconCursorFill,
    BIconCursorText,
    BIconDash,
    BIconDashCircle,
    BIconDashCircleDotted,
    BIconDashCircleFill,
    BIconDashLg,
    BIconDashSquare,
    BIconDashSquareDotted,
    BIconDashSquareFill,
    BIconDatabase,
    BIconDatabaseAdd,
    BIconDatabaseCheck,
    BIconDatabaseDash,
    BIconDatabaseDown,
    BIconDatabaseExclamation,
    BIconDatabaseFill,
    BIconDatabaseFillAdd,
    BIconDatabaseFillCheck,
    BIconDatabaseFillDash,
    BIconDatabaseFillDown,
    BIconDatabaseFillExclamation,
    BIconDatabaseFillGear,
    BIconDatabaseFillLock,
    BIconDatabaseFillSlash,
    BIconDatabaseFillUp,
    BIconDatabaseFillX,
    BIconDatabaseGear,
    BIconDatabaseLock,
    BIconDatabaseSlash,
    BIconDatabaseUp,
    BIconDatabaseX,
    BIconDeviceHdd,
    BIconDeviceHddFill,
    BIconDeviceSsd,
    BIconDeviceSsdFill,
    BIconDiagram2,
    BIconDiagram2Fill,
    BIconDiagram3,
    BIconDiagram3Fill,
    BIconDiamond,
    BIconDiamondFill,
    BIconDiamondHalf,
    BIconDice1,
    BIconDice1Fill,
    BIconDice2,
    BIconDice2Fill,
    BIconDice3,
    BIconDice3Fill,
    BIconDice4,
    BIconDice4Fill,
    BIconDice5,
    BIconDice5Fill,
    BIconDice6,
    BIconDice6Fill,
    BIconDisc,
    BIconDiscFill,
    BIconDiscord,
    BIconDisplay,
    BIconDisplayFill,
    BIconDisplayport,
    BIconDisplayportFill,
    BIconDistributeHorizontal,
    BIconDistributeVertical,
    BIconDoorClosed,
    BIconDoorClosedFill,
    BIconDoorOpen,
    BIconDoorOpenFill,
    BIconDot,
    BIconDownload,
    BIconDpad,
    BIconDpadFill,
    BIconDribbble,
    BIconDropbox,
    BIconDroplet,
    BIconDropletFill,
    BIconDropletHalf,
    BIconDuffle,
    BIconDuffleFill,
    BIconEar,
    BIconEarFill,
    BIconEarbuds,
    BIconEasel,
    BIconEasel2,
    BIconEasel2Fill,
    BIconEasel3,
    BIconEasel3Fill,
    BIconEaselFill,
    BIconEgg,
    BIconEggFill,
    BIconEggFried,
    BIconEject,
    BIconEjectFill,
    BIconEmojiAngry,
    BIconEmojiAngryFill,
    BIconEmojiAstonished,
    BIconEmojiAstonishedFill,
    BIconEmojiDizzy,
    BIconEmojiDizzyFill,
    BIconEmojiExpressionless,
    BIconEmojiExpressionlessFill,
    BIconEmojiFrown,
    BIconEmojiFrownFill,
    BIconEmojiGrimace,
    BIconEmojiGrimaceFill,
    BIconEmojiGrin,
    BIconEmojiGrinFill,
    BIconEmojiHeartEyes,
    BIconEmojiHeartEyesFill,
    BIconEmojiKiss,
    BIconEmojiKissFill,
    BIconEmojiLaughing,
    BIconEmojiLaughingFill,
    BIconEmojiNeutral,
    BIconEmojiNeutralFill,
    BIconEmojiSmile,
    BIconEmojiSmileFill,
    BIconEmojiSmileUpsideDown,
    BIconEmojiSmileUpsideDownFill,
    BIconEmojiSunglasses,
    BIconEmojiSunglassesFill,
    BIconEmojiSurprise,
    BIconEmojiSurpriseFill,
    BIconEmojiTear,
    BIconEmojiTearFill,
    BIconEmojiWink,
    BIconEmojiWinkFill,
    BIconEnvelope,
    BIconEnvelopeArrowDown,
    BIconEnvelopeArrowDownFill,
    BIconEnvelopeArrowUp,
    BIconEnvelopeArrowUpFill,
    BIconEnvelopeAt,
    BIconEnvelopeAtFill,
    BIconEnvelopeCheck,
    BIconEnvelopeCheckFill,
    BIconEnvelopeDash,
    BIconEnvelopeDashFill,
    BIconEnvelopeExclamation,
    BIconEnvelopeExclamationFill,
    BIconEnvelopeFill,
    BIconEnvelopeHeart,
    BIconEnvelopeHeartFill,
    BIconEnvelopeOpen,
    BIconEnvelopeOpenFill,
    BIconEnvelopeOpenHeart,
    BIconEnvelopeOpenHeartFill,
    BIconEnvelopePaper,
    BIconEnvelopePaperFill,
    BIconEnvelopePaperHeart,
    BIconEnvelopePaperHeartFill,
    BIconEnvelopePlus,
    BIconEnvelopePlusFill,
    BIconEnvelopeSlash,
    BIconEnvelopeSlashFill,
    BIconEnvelopeX,
    BIconEnvelopeXFill,
    BIconEraser,
    BIconEraserFill,
    BIconEscape,
    BIconEthernet,
    BIconEvFront,
    BIconEvFrontFill,
    BIconEvStation,
    BIconEvStationFill,
    BIconExclamation,
    BIconExclamationCircle,
    BIconExclamationCircleFill,
    BIconExclamationDiamond,
    BIconExclamationDiamondFill,
    BIconExclamationLg,
    BIconExclamationOctagon,
    BIconExclamationOctagonFill,
    BIconExclamationSquare,
    BIconExclamationSquareFill,
    BIconExclamationTriangle,
    BIconExclamationTriangleFill,
    BIconExclude,
    BIconExplicit,
    BIconExplicitFill,
    BIconExposure,
    BIconEye,
    BIconEyeFill,
    BIconEyeSlash,
    BIconEyeSlashFill,
    BIconEyedropper,
    BIconEyeglasses,
    BIconFacebook,
    BIconFan,
    BIconFastForward,
    BIconFastForwardBtn,
    BIconFastForwardBtnFill,
    BIconFastForwardCircle,
    BIconFastForwardCircleFill,
    BIconFastForwardFill,
    BIconFeather,
    BIconFeather2,
    BIconFile,
    BIconFileArrowDown,
    BIconFileArrowDownFill,
    BIconFileArrowUp,
    BIconFileArrowUpFill,
    BIconFileBarGraph,
    BIconFileBarGraphFill,
    BIconFileBinary,
    BIconFileBinaryFill,
    BIconFileBreak,
    BIconFileBreakFill,
    BIconFileCheck,
    BIconFileCheckFill,
    BIconFileCode,
    BIconFileCodeFill,
    BIconFileDiff,
    BIconFileDiffFill,
    BIconFileEarmark,
    BIconFileEarmarkArrowDown,
    BIconFileEarmarkArrowDownFill,
    BIconFileEarmarkArrowUp,
    BIconFileEarmarkArrowUpFill,
    BIconFileEarmarkBarGraph,
    BIconFileEarmarkBarGraphFill,
    BIconFileEarmarkBinary,
    BIconFileEarmarkBinaryFill,
    BIconFileEarmarkBreak,
    BIconFileEarmarkBreakFill,
    BIconFileEarmarkCheck,
    BIconFileEarmarkCheckFill,
    BIconFileEarmarkCode,
    BIconFileEarmarkCodeFill,
    BIconFileEarmarkDiff,
    BIconFileEarmarkDiffFill,
    BIconFileEarmarkEasel,
    BIconFileEarmarkEaselFill,
    BIconFileEarmarkExcel,
    BIconFileEarmarkExcelFill,
    BIconFileEarmarkFill,
    BIconFileEarmarkFont,
    BIconFileEarmarkFontFill,
    BIconFileEarmarkImage,
    BIconFileEarmarkImageFill,
    BIconFileEarmarkLock,
    BIconFileEarmarkLock2,
    BIconFileEarmarkLock2Fill,
    BIconFileEarmarkLockFill,
    BIconFileEarmarkMedical,
    BIconFileEarmarkMedicalFill,
    BIconFileEarmarkMinus,
    BIconFileEarmarkMinusFill,
    BIconFileEarmarkMusic,
    BIconFileEarmarkMusicFill,
    BIconFileEarmarkPdf,
    BIconFileEarmarkPdfFill,
    BIconFileEarmarkPerson,
    BIconFileEarmarkPersonFill,
    BIconFileEarmarkPlay,
    BIconFileEarmarkPlayFill,
    BIconFileEarmarkPlus,
    BIconFileEarmarkPlusFill,
    BIconFileEarmarkPost,
    BIconFileEarmarkPostFill,
    BIconFileEarmarkPpt,
    BIconFileEarmarkPptFill,
    BIconFileEarmarkRichtext,
    BIconFileEarmarkRichtextFill,
    BIconFileEarmarkRuled,
    BIconFileEarmarkRuledFill,
    BIconFileEarmarkSlides,
    BIconFileEarmarkSlidesFill,
    BIconFileEarmarkSpreadsheet,
    BIconFileEarmarkSpreadsheetFill,
    BIconFileEarmarkText,
    BIconFileEarmarkTextFill,
    BIconFileEarmarkWord,
    BIconFileEarmarkWordFill,
    BIconFileEarmarkX,
    BIconFileEarmarkXFill,
    BIconFileEarmarkZip,
    BIconFileEarmarkZipFill,
    BIconFileEasel,
    BIconFileEaselFill,
    BIconFileExcel,
    BIconFileExcelFill,
    BIconFileFill,
    BIconFileFont,
    BIconFileFontFill,
    BIconFileImage,
    BIconFileImageFill,
    BIconFileLock,
    BIconFileLock2,
    BIconFileLock2Fill,
    BIconFileLockFill,
    BIconFileMedical,
    BIconFileMedicalFill,
    BIconFileMinus,
    BIconFileMinusFill,
    BIconFileMusic,
    BIconFileMusicFill,
    BIconFilePdf,
    BIconFilePdfFill,
    BIconFilePerson,
    BIconFilePersonFill,
    BIconFilePlay,
    BIconFilePlayFill,
    BIconFilePlus,
    BIconFilePlusFill,
    BIconFilePost,
    BIconFilePostFill,
    BIconFilePpt,
    BIconFilePptFill,
    BIconFileRichtext,
    BIconFileRichtextFill,
    BIconFileRuled,
    BIconFileRuledFill,
    BIconFileSlides,
    BIconFileSlidesFill,
    BIconFileSpreadsheet,
    BIconFileSpreadsheetFill,
    BIconFileText,
    BIconFileTextFill,
    BIconFileWord,
    BIconFileWordFill,
    BIconFileX,
    BIconFileXFill,
    BIconFileZip,
    BIconFileZipFill,
    BIconFiles,
    BIconFilesAlt,
    BIconFiletypeAac,
    BIconFiletypeAi,
    BIconFiletypeBmp,
    BIconFiletypeCs,
    BIconFiletypeCss,
    BIconFiletypeCsv,
    BIconFiletypeDoc,
    BIconFiletypeDocx,
    BIconFiletypeExe,
    BIconFiletypeGif,
    BIconFiletypeHeic,
    BIconFiletypeHtml,
    BIconFiletypeJava,
    BIconFiletypeJpg,
    BIconFiletypeJs,
    BIconFiletypeJson,
    BIconFiletypeJsx,
    BIconFiletypeKey,
    BIconFiletypeM4p,
    BIconFiletypeMd,
    BIconFiletypeMdx,
    BIconFiletypeMov,
    BIconFiletypeMp3,
    BIconFiletypeMp4,
    BIconFiletypeOtf,
    BIconFiletypePdf,
    BIconFiletypePhp,
    BIconFiletypePng,
    BIconFiletypePpt,
    BIconFiletypePptx,
    BIconFiletypePsd,
    BIconFiletypePy,
    BIconFiletypeRaw,
    BIconFiletypeRb,
    BIconFiletypeSass,
    BIconFiletypeScss,
    BIconFiletypeSh,
    BIconFiletypeSql,
    BIconFiletypeSvg,
    BIconFiletypeTiff,
    BIconFiletypeTsx,
    BIconFiletypeTtf,
    BIconFiletypeTxt,
    BIconFiletypeWav,
    BIconFiletypeWoff,
    BIconFiletypeXls,
    BIconFiletypeXlsx,
    BIconFiletypeXml,
    BIconFiletypeYml,
    BIconFilm,
    BIconFilter,
    BIconFilterCircle,
    BIconFilterCircleFill,
    BIconFilterLeft,
    BIconFilterRight,
    BIconFilterSquare,
    BIconFilterSquareFill,
    BIconFingerprint,
    BIconFire,
    BIconFlag,
    BIconFlagFill,
    BIconFloppy,
    BIconFloppy2,
    BIconFloppy2Fill,
    BIconFloppyFill,
    BIconFlower1,
    BIconFlower2,
    BIconFlower3,
    BIconFolder,
    BIconFolder2,
    BIconFolder2Open,
    BIconFolderCheck,
    BIconFolderFill,
    BIconFolderMinus,
    BIconFolderPlus,
    BIconFolderSymlink,
    BIconFolderSymlinkFill,
    BIconFolderX,
    BIconFonts,
    BIconForward,
    BIconForwardFill,
    BIconFront,
    BIconFuelPump,
    BIconFuelPumpDiesel,
    BIconFuelPumpDieselFill,
    BIconFuelPumpFill,
    BIconFullscreen,
    BIconFullscreenExit,
    BIconFunnel,
    BIconFunnelFill,
    BIconGear,
    BIconGearFill,
    BIconGearWide,
    BIconGearWideConnected,
    BIconGem,
    BIconGenderAmbiguous,
    BIconGenderFemale,
    BIconGenderMale,
    BIconGenderNeuter,
    BIconGenderTrans,
    BIconGeo,
    BIconGeoAlt,
    BIconGeoAltFill,
    BIconGeoFill,
    BIconGift,
    BIconGiftFill,
    BIconGit,
    BIconGithub,
    BIconGitlab,
    BIconGlobe,
    BIconGlobe2,
    BIconGlobeAmericas,
    BIconGlobeAsiaAustralia,
    BIconGlobeCentralSouthAsia,
    BIconGlobeEuropeAfrica,
    BIconGoogle,
    BIconGooglePlay,
    BIconGpuCard,
    BIconGraphDown,
    BIconGraphDownArrow,
    BIconGraphUp,
    BIconGraphUpArrow,
    BIconGrid,
    BIconGrid1x2,
    BIconGrid1x2Fill,
    BIconGrid3x2,
    BIconGrid3x2Gap,
    BIconGrid3x2GapFill,
    BIconGrid3x3,
    BIconGrid3x3Gap,
    BIconGrid3x3GapFill,
    BIconGridFill,
    BIconGripHorizontal,
    BIconGripVertical,
    BIconHCircle,
    BIconHCircleFill,
    BIconHSquare,
    BIconHSquareFill,
    BIconHammer,
    BIconHandIndex,
    BIconHandIndexFill,
    BIconHandIndexThumb,
    BIconHandIndexThumbFill,
    BIconHandThumbsDown,
    BIconHandThumbsDownFill,
    BIconHandThumbsUp,
    BIconHandThumbsUpFill,
    BIconHandbag,
    BIconHandbagFill,
    BIconHash,
    BIconHdd,
    BIconHddFill,
    BIconHddNetwork,
    BIconHddNetworkFill,
    BIconHddRack,
    BIconHddRackFill,
    BIconHddStack,
    BIconHddStackFill,
    BIconHdmi,
    BIconHdmiFill,
    BIconHeadphones,
    BIconHeadset,
    BIconHeadsetVr,
    BIconHeart,
    BIconHeartArrow,
    BIconHeartFill,
    BIconHeartHalf,
    BIconHeartPulse,
    BIconHeartPulseFill,
    BIconHeartbreak,
    BIconHeartbreakFill,
    BIconHearts,
    BIconHeptagon,
    BIconHeptagonFill,
    BIconHeptagonHalf,
    BIconHexagon,
    BIconHexagonFill,
    BIconHexagonHalf,
    BIconHighlighter,
    BIconHighlights,
    BIconHospital,
    BIconHospitalFill,
    BIconHourglass,
    BIconHourglassBottom,
    BIconHourglassSplit,
    BIconHourglassTop,
    BIconHouse,
    BIconHouseAdd,
    BIconHouseAddFill,
    BIconHouseCheck,
    BIconHouseCheckFill,
    BIconHouseDash,
    BIconHouseDashFill,
    BIconHouseDoor,
    BIconHouseDoorFill,
    BIconHouseDown,
    BIconHouseDownFill,
    BIconHouseExclamation,
    BIconHouseExclamationFill,
    BIconHouseFill,
    BIconHouseGear,
    BIconHouseGearFill,
    BIconHouseHeart,
    BIconHouseHeartFill,
    BIconHouseLock,
    BIconHouseLockFill,
    BIconHouseSlash,
    BIconHouseSlashFill,
    BIconHouseUp,
    BIconHouseUpFill,
    BIconHouseX,
    BIconHouseXFill,
    BIconHouses,
    BIconHousesFill,
    BIconHr,
    BIconHurricane,
    BIconHypnotize,
    BIconImage,
    BIconImageAlt,
    BIconImageFill,
    BIconImages,
    BIconInbox,
    BIconInboxFill,
    BIconInboxes,
    BIconInboxesFill,
    BIconIncognito,
    BIconIndent,
    BIconInfinity,
    BIconInfo,
    BIconInfoCircle,
    BIconInfoCircleFill,
    BIconInfoLg,
    BIconInfoSquare,
    BIconInfoSquareFill,
    BIconInputCursor,
    BIconInputCursorText,
    BIconInstagram,
    BIconIntersect,
    BIconJournal,
    BIconJournalAlbum,
    BIconJournalArrowDown,
    BIconJournalArrowUp,
    BIconJournalBookmark,
    BIconJournalBookmarkFill,
    BIconJournalCheck,
    BIconJournalCode,
    BIconJournalMedical,
    BIconJournalMinus,
    BIconJournalPlus,
    BIconJournalRichtext,
    BIconJournalText,
    BIconJournalX,
    BIconJournals,
    BIconJoystick,
    BIconJustify,
    BIconJustifyLeft,
    BIconJustifyRight,
    BIconKanban,
    BIconKanbanFill,
    BIconKey,
    BIconKeyFill,
    BIconKeyboard,
    BIconKeyboardFill,
    BIconLadder,
    BIconLamp,
    BIconLampFill,
    BIconLaptop,
    BIconLaptopFill,
    BIconLayerBackward,
    BIconLayerForward,
    BIconLayers,
    BIconLayersFill,
    BIconLayersHalf,
    BIconLayoutSidebar,
    BIconLayoutSidebarInset,
    BIconLayoutSidebarInsetReverse,
    BIconLayoutSidebarReverse,
    BIconLayoutSplit,
    BIconLayoutTextSidebar,
    BIconLayoutTextSidebarReverse,
    BIconLayoutTextWindow,
    BIconLayoutTextWindowReverse,
    BIconLayoutThreeColumns,
    BIconLayoutWtf,
    BIconLifePreserver,
    BIconLightbulb,
    BIconLightbulbFill,
    BIconLightbulbOff,
    BIconLightbulbOffFill,
    BIconLightning,
    BIconLightningCharge,
    BIconLightningChargeFill,
    BIconLightningFill,
    BIconLine,
    BIconLink,
    BIconLink45deg,
    BIconLinkedin,
    BIconList,
    BIconListCheck,
    BIconListColumns,
    BIconListColumnsReverse,
    BIconListNested,
    BIconListOl,
    BIconListStars,
    BIconListTask,
    BIconListUl,
    BIconLock,
    BIconLockFill,
    BIconLuggage,
    BIconLuggageFill,
    BIconLungs,
    BIconLungsFill,
    BIconMagic,
    BIconMagnet,
    BIconMagnetFill,
    BIconMailbox,
    BIconMailbox2,
    BIconMailbox2Flag,
    BIconMailboxFlag,
    BIconMap,
    BIconMapFill,
    BIconMarkdown,
    BIconMarkdownFill,
    BIconMarkerTip,
    BIconMask,
    BIconMastodon,
    BIconMedium,
    BIconMegaphone,
    BIconMegaphoneFill,
    BIconMemory,
    BIconMenuApp,
    BIconMenuAppFill,
    BIconMenuButton,
    BIconMenuButtonFill,
    BIconMenuButtonWide,
    BIconMenuButtonWideFill,
    BIconMenuDown,
    BIconMenuUp,
    BIconMessenger,
    BIconMeta,
    BIconMic,
    BIconMicFill,
    BIconMicMute,
    BIconMicMuteFill,
    BIconMicrosoft,
    BIconMicrosoftTeams,
    BIconMinecart,
    BIconMinecartLoaded,
    BIconModem,
    BIconModemFill,
    BIconMoisture,
    BIconMoon,
    BIconMoonFill,
    BIconMoonStars,
    BIconMoonStarsFill,
    BIconMortarboard,
    BIconMortarboardFill,
    BIconMotherboard,
    BIconMotherboardFill,
    BIconMouse,
    BIconMouse2,
    BIconMouse2Fill,
    BIconMouse3,
    BIconMouse3Fill,
    BIconMouseFill,
    BIconMusicNote,
    BIconMusicNoteBeamed,
    BIconMusicNoteList,
    BIconMusicPlayer,
    BIconMusicPlayerFill,
    BIconNewspaper,
    BIconNintendoSwitch,
    BIconNodeMinus,
    BIconNodeMinusFill,
    BIconNodePlus,
    BIconNodePlusFill,
    BIconNoiseReduction,
    BIconNut,
    BIconNutFill,
    BIconNvidia,
    BIconNvme,
    BIconNvmeFill,
    BIconOctagon,
    BIconOctagonFill,
    BIconOctagonHalf,
    BIconOpencollective,
    BIconOpticalAudio,
    BIconOpticalAudioFill,
    BIconOption,
    BIconOutlet,
    BIconPCircle,
    BIconPCircleFill,
    BIconPSquare,
    BIconPSquareFill,
    BIconPaintBucket,
    BIconPalette,
    BIconPalette2,
    BIconPaletteFill,
    BIconPaperclip,
    BIconParagraph,
    BIconPass,
    BIconPassFill,
    BIconPassport,
    BIconPassportFill,
    BIconPatchCheck,
    BIconPatchCheckFill,
    BIconPatchExclamation,
    BIconPatchExclamationFill,
    BIconPatchMinus,
    BIconPatchMinusFill,
    BIconPatchPlus,
    BIconPatchPlusFill,
    BIconPatchQuestion,
    BIconPatchQuestionFill,
    BIconPause,
    BIconPauseBtn,
    BIconPauseBtnFill,
    BIconPauseCircle,
    BIconPauseCircleFill,
    BIconPauseFill,
    BIconPaypal,
    BIconPc,
    BIconPcDisplay,
    BIconPcDisplayHorizontal,
    BIconPcHorizontal,
    BIconPciCard,
    BIconPciCardNetwork,
    BIconPciCardSound,
    BIconPeace,
    BIconPeaceFill,
    BIconPen,
    BIconPenFill,
    BIconPencil,
    BIconPencilFill,
    BIconPencilSquare,
    BIconPentagon,
    BIconPentagonFill,
    BIconPentagonHalf,
    BIconPeople,
    BIconPeopleFill,
    BIconPercent,
    BIconPerson,
    BIconPersonAdd,
    BIconPersonArmsUp,
    BIconPersonBadge,
    BIconPersonBadgeFill,
    BIconPersonBoundingBox,
    BIconPersonCheck,
    BIconPersonCheckFill,
    BIconPersonCircle,
    BIconPersonDash,
    BIconPersonDashFill,
    BIconPersonDown,
    BIconPersonExclamation,
    BIconPersonFill,
    BIconPersonFillAdd,
    BIconPersonFillCheck,
    BIconPersonFillDash,
    BIconPersonFillDown,
    BIconPersonFillExclamation,
    BIconPersonFillGear,
    BIconPersonFillLock,
    BIconPersonFillSlash,
    BIconPersonFillUp,
    BIconPersonFillX,
    BIconPersonGear,
    BIconPersonHeart,
    BIconPersonHearts,
    BIconPersonLinesFill,
    BIconPersonLock,
    BIconPersonPlus,
    BIconPersonPlusFill,
    BIconPersonRaisedHand,
    BIconPersonRolodex,
    BIconPersonSlash,
    BIconPersonSquare,
    BIconPersonStanding,
    BIconPersonStandingDress,
    BIconPersonUp,
    BIconPersonVcard,
    BIconPersonVcardFill,
    BIconPersonVideo,
    BIconPersonVideo2,
    BIconPersonVideo3,
    BIconPersonWalking,
    BIconPersonWheelchair,
    BIconPersonWorkspace,
    BIconPersonX,
    BIconPersonXFill,
    BIconPhone,
    BIconPhoneFill,
    BIconPhoneFlip,
    BIconPhoneLandscape,
    BIconPhoneLandscapeFill,
    BIconPhoneVibrate,
    BIconPhoneVibrateFill,
    BIconPieChart,
    BIconPieChartFill,
    BIconPiggyBank,
    BIconPiggyBankFill,
    BIconPin,
    BIconPinAngle,
    BIconPinAngleFill,
    BIconPinFill,
    BIconPinMap,
    BIconPinMapFill,
    BIconPinterest,
    BIconPip,
    BIconPipFill,
    BIconPlay,
    BIconPlayBtn,
    BIconPlayBtnFill,
    BIconPlayCircle,
    BIconPlayCircleFill,
    BIconPlayFill,
    BIconPlaystation,
    BIconPlug,
    BIconPlugFill,
    BIconPlugin,
    BIconPlus,
    BIconPlusCircle,
    BIconPlusCircleDotted,
    BIconPlusCircleFill,
    BIconPlusLg,
    BIconPlusSlashMinus,
    BIconPlusSquare,
    BIconPlusSquareDotted,
    BIconPlusSquareFill,
    BIconPostage,
    BIconPostageFill,
    BIconPostageHeart,
    BIconPostageHeartFill,
    BIconPostcard,
    BIconPostcardFill,
    BIconPostcardHeart,
    BIconPostcardHeartFill,
    BIconPower,
    BIconPrescription,
    BIconPrescription2,
    BIconPrinter,
    BIconPrinterFill,
    BIconProjector,
    BIconProjectorFill,
    BIconPuzzle,
    BIconPuzzleFill,
    BIconQrCode,
    BIconQrCodeScan,
    BIconQuestion,
    BIconQuestionCircle,
    BIconQuestionCircleFill,
    BIconQuestionDiamond,
    BIconQuestionDiamondFill,
    BIconQuestionLg,
    BIconQuestionOctagon,
    BIconQuestionOctagonFill,
    BIconQuestionSquare,
    BIconQuestionSquareFill,
    BIconQuora,
    BIconQuote,
    BIconRCircle,
    BIconRCircleFill,
    BIconRSquare,
    BIconRSquareFill,
    BIconRadar,
    BIconRadioactive,
    BIconRainbow,
    BIconReceipt,
    BIconReceiptCutoff,
    BIconReception0,
    BIconReception1,
    BIconReception2,
    BIconReception3,
    BIconReception4,
    BIconRecord,
    BIconRecord2,
    BIconRecord2Fill,
    BIconRecordBtn,
    BIconRecordBtnFill,
    BIconRecordCircle,
    BIconRecordCircleFill,
    BIconRecordFill,
    BIconRecycle,
    BIconReddit,
    BIconRegex,
    BIconRepeat,
    BIconRepeat1,
    BIconReply,
    BIconReplyAll,
    BIconReplyAllFill,
    BIconReplyFill,
    BIconRewind,
    BIconRewindBtn,
    BIconRewindBtnFill,
    BIconRewindCircle,
    BIconRewindCircleFill,
    BIconRewindFill,
    BIconRobot,
    BIconRocket,
    BIconRocketFill,
    BIconRocketTakeoff,
    BIconRocketTakeoffFill,
    BIconRouter,
    BIconRouterFill,
    BIconRss,
    BIconRssFill,
    BIconRulers,
    BIconSafe,
    BIconSafe2,
    BIconSafe2Fill,
    BIconSafeFill,
    BIconSave,
    BIconSave2,
    BIconSave2Fill,
    BIconSaveFill,
    BIconScissors,
    BIconScooter,
    BIconScrewdriver,
    BIconSdCard,
    BIconSdCardFill,
    BIconSearch,
    BIconSearchHeart,
    BIconSearchHeartFill,
    BIconSegmentedNav,
    BIconSend,
    BIconSendArrowDown,
    BIconSendArrowDownFill,
    BIconSendArrowUp,
    BIconSendArrowUpFill,
    BIconSendCheck,
    BIconSendCheckFill,
    BIconSendDash,
    BIconSendDashFill,
    BIconSendExclamation,
    BIconSendExclamationFill,
    BIconSendFill,
    BIconSendPlus,
    BIconSendPlusFill,
    BIconSendSlash,
    BIconSendSlashFill,
    BIconSendX,
    BIconSendXFill,
    BIconServer,
    BIconShadows,
    BIconShare,
    BIconShareFill,
    BIconShield,
    BIconShieldCheck,
    BIconShieldExclamation,
    BIconShieldFill,
    BIconShieldFillCheck,
    BIconShieldFillExclamation,
    BIconShieldFillMinus,
    BIconShieldFillPlus,
    BIconShieldFillX,
    BIconShieldLock,
    BIconShieldLockFill,
    BIconShieldMinus,
    BIconShieldPlus,
    BIconShieldShaded,
    BIconShieldSlash,
    BIconShieldSlashFill,
    BIconShieldX,
    BIconShift,
    BIconShiftFill,
    BIconShop,
    BIconShopWindow,
    BIconShuffle,
    BIconSignDeadEnd,
    BIconSignDeadEndFill,
    BIconSignDoNotEnter,
    BIconSignDoNotEnterFill,
    BIconSignIntersection,
    BIconSignIntersectionFill,
    BIconSignIntersectionSide,
    BIconSignIntersectionSideFill,
    BIconSignIntersectionT,
    BIconSignIntersectionTFill,
    BIconSignIntersectionY,
    BIconSignIntersectionYFill,
    BIconSignMergeLeft,
    BIconSignMergeLeftFill,
    BIconSignMergeRight,
    BIconSignMergeRightFill,
    BIconSignNoLeftTurn,
    BIconSignNoLeftTurnFill,
    BIconSignNoParking,
    BIconSignNoParkingFill,
    BIconSignNoRightTurn,
    BIconSignNoRightTurnFill,
    BIconSignRailroad,
    BIconSignRailroadFill,
    BIconSignStop,
    BIconSignStopFill,
    BIconSignStopLights,
    BIconSignStopLightsFill,
    BIconSignTurnLeft,
    BIconSignTurnLeftFill,
    BIconSignTurnRight,
    BIconSignTurnRightFill,
    BIconSignTurnSlightLeft,
    BIconSignTurnSlightLeftFill,
    BIconSignTurnSlightRight,
    BIconSignTurnSlightRightFill,
    BIconSignYield,
    BIconSignYieldFill,
    BIconSignal,
    BIconSignpost,
    BIconSignpost2,
    BIconSignpost2Fill,
    BIconSignpostFill,
    BIconSignpostSplit,
    BIconSignpostSplitFill,
    BIconSim,
    BIconSimFill,
    BIconSimSlash,
    BIconSimSlashFill,
    BIconSinaWeibo,
    BIconSkipBackward,
    BIconSkipBackwardBtn,
    BIconSkipBackwardBtnFill,
    BIconSkipBackwardCircle,
    BIconSkipBackwardCircleFill,
    BIconSkipBackwardFill,
    BIconSkipEnd,
    BIconSkipEndBtn,
    BIconSkipEndBtnFill,
    BIconSkipEndCircle,
    BIconSkipEndCircleFill,
    BIconSkipEndFill,
    BIconSkipForward,
    BIconSkipForwardBtn,
    BIconSkipForwardBtnFill,
    BIconSkipForwardCircle,
    BIconSkipForwardCircleFill,
    BIconSkipForwardFill,
    BIconSkipStart,
    BIconSkipStartBtn,
    BIconSkipStartBtnFill,
    BIconSkipStartCircle,
    BIconSkipStartCircleFill,
    BIconSkipStartFill,
    BIconSkype,
    BIconSlack,
    BIconSlash,
    BIconSlashCircle,
    BIconSlashCircleFill,
    BIconSlashLg,
    BIconSlashSquare,
    BIconSlashSquareFill,
    BIconSliders,
    BIconSliders2,
    BIconSliders2Vertical,
    BIconSmartwatch,
    BIconSnapchat,
    BIconSnow,
    BIconSnow2,
    BIconSnow3,
    BIconSortAlphaDown,
    BIconSortAlphaDownAlt,
    BIconSortAlphaUp,
    BIconSortAlphaUpAlt,
    BIconSortDown,
    BIconSortDownAlt,
    BIconSortNumericDown,
    BIconSortNumericDownAlt,
    BIconSortNumericUp,
    BIconSortNumericUpAlt,
    BIconSortUp,
    BIconSortUpAlt,
    BIconSoundwave,
    BIconSourceforge,
    BIconSpeaker,
    BIconSpeakerFill,
    BIconSpeedometer,
    BIconSpeedometer2,
    BIconSpellcheck,
    BIconSpotify,
    BIconSquare,
    BIconSquareFill,
    BIconSquareHalf,
    BIconStack,
    BIconStackOverflow,
    BIconStar,
    BIconStarFill,
    BIconStarHalf,
    BIconStars,
    BIconSteam,
    BIconStickies,
    BIconStickiesFill,
    BIconSticky,
    BIconStickyFill,
    BIconStop,
    BIconStopBtn,
    BIconStopBtnFill,
    BIconStopCircle,
    BIconStopCircleFill,
    BIconStopFill,
    BIconStoplights,
    BIconStoplightsFill,
    BIconStopwatch,
    BIconStopwatchFill,
    BIconStrava,
    BIconStripe,
    BIconSubscript,
    BIconSubstack,
    BIconSubtract,
    BIconSuitClub,
    BIconSuitClubFill,
    BIconSuitDiamond,
    BIconSuitDiamondFill,
    BIconSuitHeart,
    BIconSuitHeartFill,
    BIconSuitSpade,
    BIconSuitSpadeFill,
    BIconSuitcase,
    BIconSuitcase2,
    BIconSuitcase2Fill,
    BIconSuitcaseFill,
    BIconSuitcaseLg,
    BIconSuitcaseLgFill,
    BIconSun,
    BIconSunFill,
    BIconSunglasses,
    BIconSunrise,
    BIconSunriseFill,
    BIconSunset,
    BIconSunsetFill,
    BIconSuperscript,
    BIconSymmetryHorizontal,
    BIconSymmetryVertical,
    BIconTable,
    BIconTablet,
    BIconTabletFill,
    BIconTabletLandscape,
    BIconTabletLandscapeFill,
    BIconTag,
    BIconTagFill,
    BIconTags,
    BIconTagsFill,
    BIconTaxiFront,
    BIconTaxiFrontFill,
    BIconTelegram,
    BIconTelephone,
    BIconTelephoneFill,
    BIconTelephoneForward,
    BIconTelephoneForwardFill,
    BIconTelephoneInbound,
    BIconTelephoneInboundFill,
    BIconTelephoneMinus,
    BIconTelephoneMinusFill,
    BIconTelephoneOutbound,
    BIconTelephoneOutboundFill,
    BIconTelephonePlus,
    BIconTelephonePlusFill,
    BIconTelephoneX,
    BIconTelephoneXFill,
    BIconTencentQq,
    BIconTerminal,
    BIconTerminalDash,
    BIconTerminalFill,
    BIconTerminalPlus,
    BIconTerminalSplit,
    BIconTerminalX,
    BIconTextCenter,
    BIconTextIndentLeft,
    BIconTextIndentRight,
    BIconTextLeft,
    BIconTextParagraph,
    BIconTextRight,
    BIconTextWrap,
    BIconTextarea,
    BIconTextareaResize,
    BIconTextareaT,
    BIconThermometer,
    BIconThermometerHalf,
    BIconThermometerHigh,
    BIconThermometerLow,
    BIconThermometerSnow,
    BIconThermometerSun,
    BIconThreads,
    BIconThreadsFill,
    BIconThreeDots,
    BIconThreeDotsVertical,
    BIconThunderbolt,
    BIconThunderboltFill,
    BIconTicket,
    BIconTicketDetailed,
    BIconTicketDetailedFill,
    BIconTicketFill,
    BIconTicketPerforated,
    BIconTicketPerforatedFill,
    BIconTiktok,
    BIconToggle2Off,
    BIconToggle2On,
    BIconToggleOff,
    BIconToggleOn,
    BIconToggles,
    BIconToggles2,
    BIconTools,
    BIconTornado,
    BIconTrainFreightFront,
    BIconTrainFreightFrontFill,
    BIconTrainFront,
    BIconTrainFrontFill,
    BIconTrainLightrailFront,
    BIconTrainLightrailFrontFill,
    BIconTranslate,
    BIconTransparency,
    BIconTrash,
    BIconTrash2,
    BIconTrash2Fill,
    BIconTrash3,
    BIconTrash3Fill,
    BIconTrashFill,
    BIconTree,
    BIconTreeFill,
    BIconTrello,
    BIconTriangle,
    BIconTriangleFill,
    BIconTriangleHalf,
    BIconTrophy,
    BIconTrophyFill,
    BIconTropicalStorm,
    BIconTruck,
    BIconTruckFlatbed,
    BIconTruckFront,
    BIconTruckFrontFill,
    BIconTsunami,
    BIconTv,
    BIconTvFill,
    BIconTwitch,
    BIconTwitter,
    BIconTwitterX,
    BIconType,
    BIconTypeBold,
    BIconTypeH1,
    BIconTypeH2,
    BIconTypeH3,
    BIconTypeH4,
    BIconTypeH5,
    BIconTypeH6,
    BIconTypeItalic,
    BIconTypeStrikethrough,
    BIconTypeUnderline,
    BIconUbuntu,
    BIconUiChecks,
    BIconUiChecksGrid,
    BIconUiRadios,
    BIconUiRadiosGrid,
    BIconUmbrella,
    BIconUmbrellaFill,
    BIconUnindent,
    BIconUnion,
    BIconUnity,
    BIconUniversalAccess,
    BIconUniversalAccessCircle,
    BIconUnlock,
    BIconUnlockFill,
    BIconUpc,
    BIconUpcScan,
    BIconUpload,
    BIconUsb,
    BIconUsbC,
    BIconUsbCFill,
    BIconUsbDrive,
    BIconUsbDriveFill,
    BIconUsbFill,
    BIconUsbMicro,
    BIconUsbMicroFill,
    BIconUsbMini,
    BIconUsbMiniFill,
    BIconUsbPlug,
    BIconUsbPlugFill,
    BIconUsbSymbol,
    BIconValentine,
    BIconValentine2,
    BIconVectorPen,
    BIconViewList,
    BIconViewStacked,
    BIconVignette,
    BIconVimeo,
    BIconVinyl,
    BIconVinylFill,
    BIconVirus,
    BIconVirus2,
    BIconVoicemail,
    BIconVolumeDown,
    BIconVolumeDownFill,
    BIconVolumeMute,
    BIconVolumeMuteFill,
    BIconVolumeOff,
    BIconVolumeOffFill,
    BIconVolumeUp,
    BIconVolumeUpFill,
    BIconVr,
    BIconWallet,
    BIconWallet2,
    BIconWalletFill,
    BIconWatch,
    BIconWater,
    BIconWebcam,
    BIconWebcamFill,
    BIconWechat,
    BIconWhatsapp,
    BIconWifi,
    BIconWifi1,
    BIconWifi2,
    BIconWifiOff,
    BIconWikipedia,
    BIconWind,
    BIconWindow,
    BIconWindowDash,
    BIconWindowDesktop,
    BIconWindowDock,
    BIconWindowFullscreen,
    BIconWindowPlus,
    BIconWindowSidebar,
    BIconWindowSplit,
    BIconWindowStack,
    BIconWindowX,
    BIconWindows,
    BIconWordpress,
    BIconWrench,
    BIconWrenchAdjustable,
    BIconWrenchAdjustableCircle,
    BIconWrenchAdjustableCircleFill,
    BIconX,
    BIconXCircle,
    BIconXCircleFill,
    BIconXDiamond,
    BIconXDiamondFill,
    BIconXLg,
    BIconXOctagon,
    BIconXOctagonFill,
    BIconXSquare,
    BIconXSquareFill,
    BIconXbox,
    BIconYelp,
    BIconYinYang,
    BIconYoutube,
    BIconZoomIn,
    BIconZoomOut
  }
})

// Export the BootstrapVueIcons plugin installer
// Mainly for the stand-alone bootstrap-vue-icons.xxx.js builds
export const BootstrapVueIcons = /*#__PURE__*/ pluginFactoryNoConfig(
  { plugins: { IconsPlugin } },
  { NAME: 'BootstrapVueIcons' }
)

// --- END AUTO-GENERATED FILE ---
